/* Componentes do design system "Painel — Design System de Operação".

   GERADO a partir do `_ds_bundle.js` do projeto do Claude Design
   (557d19c3-4833-47a4-a90c-d7a5cdc53211) por `ferramentas/converter_ds.py`.

   **Não edite este arquivo à mão.** O código dos componentes é o do design,
   verbatim; o que a conversão faz é trocar o embrulho: o bundle registra tudo
   em `window.<namespace>` dentro de try/catch, e aqui vira módulo ES com
   exports nomeados. Regerar depois de qualquer mudança no design é o caminho —
   editar aqui faz a próxima regeração apagar a correção.

   Cada componente injeta o próprio CSS uma vez, na primeira renderização
   (`function estilo()`), e usa só os tokens de `estilos/tokens/`. Por isso não
   existe folha de estilo de componente separada.

   27 componentes: GLIFOS, Icone, PlayerAudio, CampoBusca, CartaoMetrica, Alternador, Botao, Estado, BotaoIcone, Modal, Notificacao, PilhaNotificacoes, PainelLateral, Caixa, TabelaDensa, Campo, Selecao, BarraFiltros, IndicadorEntrega, IndicadorPresenca, Selo, SeloControle, SeloConversa, SeloProcessamento, BolhaMensagem, SeloSentimento, ItemConversa
*/

import React from 'react';

const __ds_scope = {};
const __ds_ns = { __errors: [] };
void __ds_ns;

// components/icone/Icone.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Conjunto Lucide 0.469.0 (licença ISC), copiado verbatim do pacote lucide-static.
   Nenhum glifo foi redesenhado. Os arquivos .svg originais estão em assets/icones/.
   Todos compartilham viewBox 24, traço 2, pontas e junções arredondadas. */
const GLIFOS = {
  "activity": "<path d=\"M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2\" />",
  "archive": "<rect width=\"20\" height=\"5\" x=\"2\" y=\"3\" rx=\"1\" /><path d=\"M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8\" /><path d=\"M10 12h4\" />",
  "arrow-down": "<path d=\"M12 5v14\" /><path d=\"m19 12-7 7-7-7\" />",
  "arrow-up": "<path d=\"m5 12 7-7 7 7\" /><path d=\"M12 19V5\" />",
  "arrow-up-down": "<path d=\"m21 16-4 4-4-4\" /><path d=\"M17 20V4\" /><path d=\"m3 8 4-4 4 4\" /><path d=\"M7 4v16\" />",
  "bell": "<path d=\"M10.268 21a2 2 0 0 0 3.464 0\" /><path d=\"M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326\" />",
  "bell-off": "<path d=\"M10.268 21a2 2 0 0 0 3.464 0\" /><path d=\"M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742\" /><path d=\"m2 2 20 20\" /><path d=\"M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05\" />",
  "bot": "<path d=\"M12 8V4H8\" /><rect width=\"16\" height=\"12\" x=\"4\" y=\"8\" rx=\"2\" /><path d=\"M2 14h2\" /><path d=\"M20 14h2\" /><path d=\"M15 13v2\" /><path d=\"M9 13v2\" />",
  "building-2": "<path d=\"M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z\" /><path d=\"M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2\" /><path d=\"M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2\" /><path d=\"M10 6h4\" /><path d=\"M10 10h4\" /><path d=\"M10 14h4\" /><path d=\"M10 18h4\" />",
  "calendar": "<path d=\"M8 2v4\" /><path d=\"M16 2v4\" /><rect width=\"18\" height=\"18\" x=\"3\" y=\"4\" rx=\"2\" /><path d=\"M3 10h18\" />",
  "chart-column": "<path d=\"M3 3v16a2 2 0 0 0 2 2h16\" /><path d=\"M18 17V9\" /><path d=\"M13 17V5\" /><path d=\"M8 17v-3\" />",
  "check": "<path d=\"M20 6 9 17l-5-5\" />",
  "check-check": "<path d=\"M18 6 7 17l-5-5\" /><path d=\"m22 10-7.5 7.5L13 16\" />",
  "chevron-down": "<path d=\"m6 9 6 6 6-6\" />",
  "chevron-left": "<path d=\"m15 18-6-6 6-6\" />",
  "chevron-right": "<path d=\"m9 18 6-6-6-6\" />",
  "chevron-up": "<path d=\"m18 15-6-6-6 6\" />",
  "chevrons-up-down": "<path d=\"m7 15 5 5 5-5\" /><path d=\"m7 9 5-5 5 5\" />",
  "circle": "<circle cx=\"12\" cy=\"12\" r=\"10\" />",
  "circle-alert": "<circle cx=\"12\" cy=\"12\" r=\"10\" /><line x1=\"12\" x2=\"12\" y1=\"8\" y2=\"12\" /><line x1=\"12\" x2=\"12.01\" y1=\"16\" y2=\"16\" />",
  "circle-check": "<circle cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"m9 12 2 2 4-4\" />",
  "circle-dashed": "<path d=\"M10.1 2.182a10 10 0 0 1 3.8 0\" /><path d=\"M13.9 21.818a10 10 0 0 1-3.8 0\" /><path d=\"M17.609 3.721a10 10 0 0 1 2.69 2.7\" /><path d=\"M2.182 13.9a10 10 0 0 1 0-3.8\" /><path d=\"M20.279 17.609a10 10 0 0 1-2.7 2.69\" /><path d=\"M21.818 10.1a10 10 0 0 1 0 3.8\" /><path d=\"M3.721 6.391a10 10 0 0 1 2.7-2.69\" /><path d=\"M6.391 20.279a10 10 0 0 1-2.69-2.7\" />",
  "circle-slash-2": "<circle cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"M22 2 2 22\" />",
  "circle-x": "<circle cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"m15 9-6 6\" /><path d=\"m9 9 6 6\" />",
  "clock": "<circle cx=\"12\" cy=\"12\" r=\"10\" /><polyline points=\"12 6 12 12 16 14\" />",
  "clock-alert": "<path d=\"M12 6v6l4 2\" /><path d=\"M16 21.16a10 10 0 1 1 5-13.516\" /><path d=\"M20 11.5v6\" /><path d=\"M20 21.5h.01\" />",
  "copy": "<rect width=\"14\" height=\"14\" x=\"8\" y=\"8\" rx=\"2\" ry=\"2\" /><path d=\"M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2\" />",
  "corner-up-left": "<polyline points=\"9 14 4 9 9 4\" /><path d=\"M20 20v-7a4 4 0 0 0-4-4H4\" />",
  "download": "<path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\" /><polyline points=\"7 10 12 15 17 10\" /><line x1=\"12\" x2=\"12\" y1=\"15\" y2=\"3\" />",
  "ellipsis": "<circle cx=\"12\" cy=\"12\" r=\"1\" /><circle cx=\"19\" cy=\"12\" r=\"1\" /><circle cx=\"5\" cy=\"12\" r=\"1\" />",
  "external-link": "<path d=\"M15 3h6v6\" /><path d=\"M10 14 21 3\" /><path d=\"M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6\" />",
  "eye": "<path d=\"M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0\" /><circle cx=\"12\" cy=\"12\" r=\"3\" />",
  "file-text": "<path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\" /><path d=\"M14 2v4a2 2 0 0 0 2 2h4\" /><path d=\"M10 9H8\" /><path d=\"M16 13H8\" /><path d=\"M16 17H8\" />",
  "filter-x": "<path d=\"M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055\" /><path d=\"m22 3-5 5\" /><path d=\"m17 3 5 5\" />",
  "frown": "<circle cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"M16 16s-1.5-2-4-2-4 2-4 2\" /><line x1=\"9\" x2=\"9.01\" y1=\"9\" y2=\"9\" /><line x1=\"15\" x2=\"15.01\" y1=\"9\" y2=\"9\" />",
  "gauge": "<path d=\"m12 14 4-4\" /><path d=\"M3.34 19a10 10 0 1 1 17.32 0\" />",
  "hand": "<path d=\"M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2\" /><path d=\"M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2\" /><path d=\"M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8\" /><path d=\"M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15\" />",
  "hourglass": "<path d=\"M5 22h14\" /><path d=\"M5 2h14\" /><path d=\"M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22\" /><path d=\"M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2\" />",
  "image": "<rect width=\"18\" height=\"18\" x=\"3\" y=\"3\" rx=\"2\" ry=\"2\" /><circle cx=\"9\" cy=\"9\" r=\"2\" /><path d=\"m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21\" />",
  "inbox": "<polyline points=\"22 12 16 12 14 15 10 15 8 12 2 12\" /><path d=\"M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z\" />",
  "info": "<circle cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"M12 16v-4\" /><path d=\"M12 8h.01\" />",
  "key-round": "<path d=\"M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z\" /><circle cx=\"16.5\" cy=\"7.5\" r=\".5\" fill=\"currentColor\" />",
  "link": "<path d=\"M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71\" /><path d=\"M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71\" />",
  "list-filter": "<path d=\"M3 6h18\" /><path d=\"M7 12h10\" /><path d=\"M10 18h4\" />",
  "loader-circle": "<path d=\"M21 12a9 9 0 1 1-6.219-8.56\" />",
  "log-out": "<path d=\"M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4\" /><polyline points=\"16 17 21 12 16 7\" /><line x1=\"21\" x2=\"9\" y1=\"12\" y2=\"12\" />",
  "meh": "<circle cx=\"12\" cy=\"12\" r=\"10\" /><line x1=\"8\" x2=\"16\" y1=\"15\" y2=\"15\" /><line x1=\"9\" x2=\"9.01\" y1=\"9\" y2=\"9\" /><line x1=\"15\" x2=\"15.01\" y1=\"9\" y2=\"9\" />",
  "message-circle-more": "<path d=\"M7.9 20A9 9 0 1 0 4 16.1L2 22Z\" /><path d=\"M8 12h.01\" /><path d=\"M12 12h.01\" /><path d=\"M16 12h.01\" />",
  "message-square": "<path d=\"M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z\" />",
  "message-square-off": "<path d=\"M21 15V5a2 2 0 0 0-2-2H9\" /><path d=\"m2 2 20 20\" /><path d=\"M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10\" />",
  "mic": "<path d=\"M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z\" /><path d=\"M19 10v2a7 7 0 0 1-14 0v-2\" /><line x1=\"12\" x2=\"12\" y1=\"19\" y2=\"22\" />",
  "minus": "<path d=\"M5 12h14\" />",
  "paperclip": "<path d=\"M13.234 20.252 21 12.3\" /><path d=\"m16 6-8.414 8.586a2 2 0 0 0 0 2.828 2 2 0 0 0 2.828 0l8.414-8.586a4 4 0 0 0 0-5.656 4 4 0 0 0-5.656 0l-8.415 8.585a6 6 0 1 0 8.486 8.486\" />",
  "panel-left-close": "<rect width=\"18\" height=\"18\" x=\"3\" y=\"3\" rx=\"2\" /><path d=\"M9 3v18\" /><path d=\"m16 15-3-3 3-3\" />",
  "panel-right-close": "<rect width=\"18\" height=\"18\" x=\"3\" y=\"3\" rx=\"2\" /><path d=\"M15 3v18\" /><path d=\"m8 9 3 3-3 3\" />",
  "pause": "<rect x=\"14\" y=\"4\" width=\"4\" height=\"16\" rx=\"1\" /><rect x=\"6\" y=\"4\" width=\"4\" height=\"16\" rx=\"1\" />",
  "pencil": "<path d=\"M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z\" /><path d=\"m15 5 4 4\" />",
  "phone": "<path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\" />",
  "play": "<polygon points=\"6 3 20 12 6 21 6 3\" />",
  "plus": "<path d=\"M5 12h14\" /><path d=\"M12 5v14\" />",
  "refresh-cw": "<path d=\"M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8\" /><path d=\"M21 3v5h-5\" /><path d=\"M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16\" /><path d=\"M8 16H3v5\" />",
  "rotate-cw": "<path d=\"M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8\" /><path d=\"M21 3v5h-5\" />",
  "search": "<circle cx=\"11\" cy=\"11\" r=\"8\" /><path d=\"m21 21-4.3-4.3\" />",
  "send": "<path d=\"M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z\" /><path d=\"m21.854 2.147-10.94 10.939\" />",
  "settings": "<path d=\"M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z\" /><circle cx=\"12\" cy=\"12\" r=\"3\" />",
  "shield-check": "<path d=\"M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z\" /><path d=\"m9 12 2 2 4-4\" />",
  "sliders-horizontal": "<line x1=\"21\" x2=\"14\" y1=\"4\" y2=\"4\" /><line x1=\"10\" x2=\"3\" y1=\"4\" y2=\"4\" /><line x1=\"21\" x2=\"12\" y1=\"12\" y2=\"12\" /><line x1=\"8\" x2=\"3\" y1=\"12\" y2=\"12\" /><line x1=\"21\" x2=\"16\" y1=\"20\" y2=\"20\" /><line x1=\"12\" x2=\"3\" y1=\"20\" y2=\"20\" /><line x1=\"14\" x2=\"14\" y1=\"2\" y2=\"6\" /><line x1=\"8\" x2=\"8\" y1=\"10\" y2=\"14\" /><line x1=\"16\" x2=\"16\" y1=\"18\" y2=\"22\" />",
  "smile": "<circle cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"M8 14s1.5 2 4 2 4-2 4-2\" /><line x1=\"9\" x2=\"9.01\" y1=\"9\" y2=\"9\" /><line x1=\"15\" x2=\"15.01\" y1=\"9\" y2=\"9\" />",
  "square-check": "<rect width=\"18\" height=\"18\" x=\"3\" y=\"3\" rx=\"2\" /><path d=\"m9 12 2 2 4-4\" />",
  "terminal": "<polyline points=\"4 17 10 11 4 5\" /><line x1=\"12\" x2=\"20\" y1=\"19\" y2=\"19\" />",
  "timer": "<line x1=\"10\" x2=\"14\" y1=\"2\" y2=\"2\" /><line x1=\"12\" x2=\"15\" y1=\"14\" y2=\"11\" /><circle cx=\"12\" cy=\"14\" r=\"8\" />",
  "trash-2": "<path d=\"M3 6h18\" /><path d=\"M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6\" /><path d=\"M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2\" /><line x1=\"10\" x2=\"10\" y1=\"11\" y2=\"17\" /><line x1=\"14\" x2=\"14\" y1=\"11\" y2=\"17\" />",
  "triangle-alert": "<path d=\"m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3\" /><path d=\"M12 9v4\" /><path d=\"M12 17h.01\" />",
  "user-check": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2\" /><circle cx=\"9\" cy=\"7\" r=\"4\" /><polyline points=\"16 11 18 13 22 9\" />",
  "user-round": "<circle cx=\"12\" cy=\"8\" r=\"5\" /><path d=\"M20 21a8 8 0 0 0-16 0\" />",
  "users": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2\" /><circle cx=\"9\" cy=\"7\" r=\"4\" /><path d=\"M22 21v-2a4 4 0 0 0-3-3.87\" /><path d=\"M16 3.13a4 4 0 0 1 0 7.75\" />",
  "volume-2": "<path d=\"M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z\" /><path d=\"M16 9a5 5 0 0 1 0 6\" /><path d=\"M19.364 18.364a9 9 0 0 0 0-12.728\" />",
  "wifi-off": "<path d=\"M12 20h.01\" /><path d=\"M8.5 16.429a5 5 0 0 1 7 0\" /><path d=\"M5 12.859a10 10 0 0 1 5.17-2.69\" /><path d=\"M19 12.859a10 10 0 0 0-2.007-1.523\" /><path d=\"M2 8.82a15 15 0 0 1 4.177-2.643\" /><path d=\"M22 8.82a15 15 0 0 0-11.288-3.764\" /><path d=\"m2 2 20 20\" />",
  "x": "<path d=\"M18 6 6 18\" /><path d=\"m6 6 12 12\" />",
  "zap": "<path d=\"M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z\" />"
};
function Icone({
  nome,
  tamanho = 16,
  traco = 2,
  cor = "currentColor",
  rotulo,
  style,
  className,
  ...resto
}) {
  const glifo = GLIFOS[nome];
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: tamanho,
    height: tamanho,
    fill: "none",
    stroke: cor,
    strokeWidth: traco,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: rotulo ? "img" : undefined,
    "aria-label": rotulo || undefined,
    "aria-hidden": rotulo ? undefined : "true",
    className: className,
    style: {
      display: "block",
      flex: "none",
      ...style
    },
    dangerouslySetInnerHTML: {
      __html: glifo || ""
    }
  }, resto));
}
Object.assign(__ds_scope, { GLIFOS, Icone });
})();

// components/conversa/PlayerAudio.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-audio{display:inline-flex;align-items:center;gap:var(--esp-4);min-width:220px;max-width:320px;padding:var(--esp-2) var(--esp-4) var(--esp-2) var(--esp-2);background:var(--superficie-afundada);border:1px solid var(--borda-sutil);border-radius:var(--raio-pilula)}
.pn-audio--emBalao{background:rgba(0,0,0,.045);border-color:transparent}
.pn-audio__acao{display:flex;align-items:center;justify-content:center;flex:none;width:26px;height:26px;border:0;border-radius:var(--raio-pilula);background:var(--acao-primaria-fundo);color:var(--acao-primaria-texto);cursor:pointer;transition:var(--transicao-toque)}
.pn-audio__acao:hover:not(:disabled){background:var(--acao-primaria-fundo-hover)}
.pn-audio__acao:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:var(--foco-deslocamento)}
.pn-audio__acao:disabled{background:var(--superficie-desabilitada);color:var(--texto-desabilitado);cursor:not-allowed}
.pn-audio__onda{display:flex;align-items:center;gap:2px;flex:1;height:20px;min-width:0;border:0;padding:0;background:none;cursor:pointer}
.pn-audio__onda:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:var(--foco-deslocamento);border-radius:var(--raio-xs)}
.pn-audio__onda i{flex:1;min-width:2px;border-radius:1px;background:var(--borda-forte);transition:background-color var(--dur-instantanea) var(--curva-padrao)}
.pn-audio__onda i[data-tocado]{background:var(--acao-primaria-fundo)}
.pn-audio__tempo{flex:none;font:var(--texto-micro);font-variant-numeric:tabular-nums;color:var(--texto-secundario)}
.pn-audio__vel{flex:none;min-width:28px;padding:1px var(--esp-2);border:1px solid var(--borda-padrao);border-radius:var(--raio-xs);background:none;font:var(--texto-micro);font-variant-numeric:tabular-nums;color:var(--texto-secundario);cursor:pointer;transition:var(--transicao-toque)}
.pn-audio__vel:hover{border-color:var(--borda-interativa);color:var(--texto-primario)}
.pn-audio__vel:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:var(--foco-deslocamento)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "player-audio");
  s.textContent = CSS;
  document.head.appendChild(s);
}

/* Alturas fixas — a onda é decorativa e determinística, não uma leitura real do áudio. */
const ONDA = [5, 9, 14, 8, 17, 11, 6, 13, 19, 10, 7, 15, 9, 12, 5, 16, 8, 11, 6, 14, 9, 5, 12, 7];
const VELOCIDADES = ["1×", "1,5×", "2×"];
function PlayerAudio({
  duracao = "0:00",
  emBalao = false,
  desabilitado = false,
  className = "",
  ...resto
}) {
  estilo();
  const [tocando, setTocando] = React.useState(false);
  const [progresso, setProgresso] = React.useState(0);
  const [vel, setVel] = React.useState(0);
  React.useEffect(() => {
    if (!tocando) return;
    const t = setInterval(() => setProgresso(p => p >= 1 ? (setTocando(false), 0) : p + 0.02 * (vel + 1)), 90);
    return () => clearInterval(t);
  }, [tocando, vel]);
  const limite = Math.round(progresso * ONDA.length);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `pn-audio ${emBalao ? "pn-audio--emBalao" : ""} ${className}`.trim()
  }, resto), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "pn-audio__acao",
    onClick: () => setTocando(t => !t),
    disabled: desabilitado,
    "aria-label": tocando ? "Pausar áudio" : "Reproduzir áudio"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: tocando ? "pause" : "play",
    tamanho: 13
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "pn-audio__onda",
    disabled: desabilitado,
    "aria-label": `Posição do áudio, ${Math.round(progresso * 100)}%`,
    onClick: e => {
      const r = e.currentTarget.getBoundingClientRect();
      setProgresso(Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)));
    }
  }, ONDA.map((h, i) => /*#__PURE__*/React.createElement("i", {
    key: i,
    style: {
      height: h
    },
    "data-tocado": i < limite ? "" : undefined
  }))), /*#__PURE__*/React.createElement("span", {
    className: "pn-audio__tempo"
  }, duracao), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "pn-audio__vel",
    onClick: () => setVel(v => (v + 1) % 3),
    "aria-label": `Velocidade ${VELOCIDADES[vel]}`
  }, VELOCIDADES[vel]));
}
Object.assign(__ds_scope, { PlayerAudio });
})();

// components/dados/CampoBusca.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-busca{position:relative;display:flex;align-items:center;gap:var(--esp-3);height:var(--altura-controle);padding:0 var(--esp-4);background:var(--superficie-painel);border:1px solid var(--borda-padrao);border-radius:var(--raio-sm);color:var(--texto-terciario);transition:var(--transicao-toque)}
.pn-busca:hover{border-color:var(--borda-interativa)}
.pn-busca:focus-within{border-color:var(--foco-anel);outline:var(--foco-largura) solid var(--foco-anel);outline-offset:1px}
.pn-busca--sm{height:var(--altura-controle-sm)}
.pn-busca__entrada{flex:1;min-width:0;border:0;outline:0;background:none;font:var(--texto-corpo);color:var(--texto-primario)}
.pn-busca--sm .pn-busca__entrada{font:var(--texto-meta)}
.pn-busca__entrada::placeholder{color:var(--texto-terciario)}
.pn-busca__limpar{display:flex;align-items:center;justify-content:center;flex:none;width:18px;height:18px;padding:0;border:0;border-radius:var(--raio-xs);background:none;color:var(--texto-terciario);cursor:pointer}
.pn-busca__limpar:hover{background:var(--superficie-hover);color:var(--texto-primario)}
.pn-busca__limpar:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:1px}
.pn-busca__atalho{flex:none;padding:0 4px;border:1px solid var(--borda-padrao);border-radius:var(--raio-xs);font:var(--texto-codigo);line-height:15px;color:var(--texto-terciario)}
.pn-busca[data-desabilitado]{background:var(--superficie-desabilitada);border-color:var(--borda-desabilitada);color:var(--texto-desabilitado)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "campo-busca");
  s.textContent = CSS;
  document.head.appendChild(s);
}
function CampoBusca({
  valor = "",
  aoMudar,
  aoLimpar,
  placeholder = "Buscar por nome ou telefone",
  atalho,
  carregando = false,
  desabilitado = false,
  tamanho = "md",
  className = "",
  ...resto
}) {
  estilo();
  return /*#__PURE__*/React.createElement("div", {
    className: `pn-busca ${tamanho === "sm" ? "pn-busca--sm" : ""} ${className}`.trim(),
    "data-desabilitado": desabilitado ? "" : undefined
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: carregando ? "loader-circle" : "search",
    tamanho: 15,
    className: carregando ? "pn-giro" : undefined
  }), /*#__PURE__*/React.createElement("input", _extends({
    type: "search",
    className: "pn-busca__entrada",
    value: valor,
    onChange: aoMudar,
    placeholder: placeholder,
    disabled: desabilitado,
    "aria-label": placeholder
  }, resto)), valor && !desabilitado && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "pn-busca__limpar",
    onClick: aoLimpar,
    "aria-label": "Limpar busca"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "x",
    tamanho: 13
  })), atalho && !valor && /*#__PURE__*/React.createElement("kbd", {
    className: "pn-busca__atalho"
  }, atalho));
}
Object.assign(__ds_scope, { CampoBusca });
})();

// components/dados/CartaoMetrica.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-metrica{display:flex;flex-direction:column;gap:var(--esp-3);min-width:0;padding:var(--esp-interno-cartao);background:var(--superficie-elevada);border:1px solid var(--borda-sutil);border-radius:var(--raio-md);box-shadow:var(--elev-1)}
.pn-metrica--clicavel{cursor:pointer;text-align:left;transition:var(--transicao-toque),box-shadow var(--dur-rapida) var(--curva-padrao)}
.pn-metrica--clicavel:hover{border-color:var(--borda-padrao);box-shadow:var(--elev-2)}
.pn-metrica--clicavel:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:var(--foco-deslocamento)}
.pn-metrica__topo{display:flex;align-items:center;gap:var(--esp-3);color:var(--texto-terciario)}
.pn-metrica__rotulo{font:var(--texto-meta);color:var(--texto-secundario);letter-spacing:var(--letra-normal)}
.pn-metrica__valor{display:flex;align-items:baseline;gap:var(--esp-2);font:var(--texto-metrica);color:var(--texto-primario);font-variant-numeric:tabular-nums;letter-spacing:var(--letra-apertada)}
.pn-metrica__unidade{font:var(--texto-corpo-forte);color:var(--texto-terciario)}
.pn-metrica__rodape{display:flex;align-items:center;gap:var(--esp-3);flex-wrap:wrap;font:var(--texto-legenda);color:var(--texto-terciario)}
.pn-metrica__variacao{display:inline-flex;align-items:center;gap:3px;font:var(--texto-meta);font-variant-numeric:tabular-nums}
.pn-metrica__variacao[data-tom=bom]{color:var(--sucesso-texto)}
.pn-metrica__variacao[data-tom=ruim]{color:var(--erro-texto)}
.pn-metrica__variacao[data-tom=neutro]{color:var(--texto-terciario)}
.pn-metrica__esqueleto{height:34px;width:60%;border-radius:var(--raio-xs);background:var(--superficie-afundada);animation:pn-pulsar var(--dur-pulso) var(--curva-linear) infinite}
.pn-metrica__esqueleto--curto{height:14px;width:38%}
@keyframes pn-pulsar{0%,100%{opacity:1}50%{opacity:.45}}
@media (prefers-reduced-motion:reduce){.pn-metrica__esqueleto{animation:none}}
.pn-metrica__erro{display:flex;align-items:center;gap:var(--esp-3);font:var(--texto-legenda);color:var(--erro-texto)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "cartao-metrica");
  s.textContent = CSS;
  document.head.appendChild(s);
}
const SETA = {
  subiu: "arrow-up",
  desceu: "arrow-down",
  estavel: "minus"
};
function CartaoMetrica({
  rotulo,
  valor,
  unidade,
  icone,
  variacao,
  direcao = "estavel",
  sentidoBom = "subir",
  periodo,
  carregando = false,
  erro,
  aoClicar,
  className = "",
  ...resto
}) {
  estilo();
  const tom = direcao === "estavel" ? "neutro" : direcao === "subiu" === (sentidoBom === "subir") ? "bom" : "ruim";
  const Raiz = aoClicar ? "button" : "div";
  return /*#__PURE__*/React.createElement(Raiz, _extends({
    className: `pn-metrica ${aoClicar ? "pn-metrica--clicavel" : ""} ${className}`.trim(),
    onClick: aoClicar,
    type: aoClicar ? "button" : undefined
  }, resto), /*#__PURE__*/React.createElement("span", {
    className: "pn-metrica__topo"
  }, icone && /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: icone,
    tamanho: 14
  }), /*#__PURE__*/React.createElement("span", {
    className: "pn-metrica__rotulo"
  }, rotulo)), carregando ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "pn-metrica__esqueleto",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    className: "pn-metrica__esqueleto pn-metrica__esqueleto--curto",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    className: "apenas-leitor"
  }, "Carregando ", rotulo)) : erro ? /*#__PURE__*/React.createElement("span", {
    className: "pn-metrica__erro"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "circle-alert",
    tamanho: 14
  }), erro) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "pn-metrica__valor"
  }, valor, unidade && /*#__PURE__*/React.createElement("span", {
    className: "pn-metrica__unidade"
  }, unidade)), (variacao || periodo) && /*#__PURE__*/React.createElement("span", {
    className: "pn-metrica__rodape"
  }, variacao && /*#__PURE__*/React.createElement("span", {
    className: "pn-metrica__variacao",
    "data-tom": tom
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: SETA[direcao],
    tamanho: 12,
    traco: 2.5
  }), variacao), periodo && /*#__PURE__*/React.createElement("span", null, periodo))));
}
Object.assign(__ds_scope, { CartaoMetrica });
})();

// components/primitivos/Alternador.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-alt{display:flex;align-items:flex-start;gap:var(--esp-5);cursor:pointer}
.pn-alt[data-desabilitado]{cursor:not-allowed}
.pn-alt__trilho{position:relative;flex:none;width:34px;height:20px;margin-top:1px;border-radius:var(--raio-pilula);background:var(--base-neutro-300);border:1px solid transparent;transition:background-color var(--dur-rapida) var(--curva-padrao)}
.pn-alt__nativo{position:absolute;inset:0;opacity:0;margin:0;cursor:inherit}
.pn-alt__nativo:focus-visible + .pn-alt__botao{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:var(--foco-deslocamento)}
.pn-alt__botao{position:absolute;inset:0;border-radius:inherit;pointer-events:none}
.pn-alt__pino{position:absolute;top:2px;left:2px;display:flex;align-items:center;justify-content:center;width:14px;height:14px;border-radius:var(--raio-pilula);background:var(--base-neutro-0);color:var(--sucesso-texto);box-shadow:var(--elev-1);transition:transform var(--dur-rapida) var(--curva-padrao)}
.pn-alt[data-ligado] .pn-alt__trilho{background:var(--sucesso-solido)}
.pn-alt[data-ligado] .pn-alt__pino{transform:translateX(14px)}
.pn-alt[data-desabilitado] .pn-alt__trilho{background:var(--borda-desabilitada)}
.pn-alt[data-desabilitado] .pn-alt__pino{background:var(--superficie-desabilitada);color:var(--texto-desabilitado);box-shadow:none}
.pn-alt--sm .pn-alt__trilho{width:28px;height:16px}
.pn-alt--sm .pn-alt__pino{width:12px;height:12px;top:1px;left:1px}
.pn-alt--sm[data-ligado] .pn-alt__pino{transform:translateX(12px)}
.pn-alt__texto{display:flex;flex-direction:column;gap:1px;min-width:0}
.pn-alt__rotulo{font:var(--texto-corpo);color:var(--texto-primario)}
.pn-alt[data-desabilitado] .pn-alt__rotulo{color:var(--texto-desabilitado)}
.pn-alt__descricao{font:var(--texto-legenda);color:var(--texto-terciario);text-wrap:pretty}
.pn-alt__estado{font:var(--texto-legenda);color:var(--texto-terciario);margin-left:auto;padding-left:var(--esp-5);white-space:nowrap}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "alternador");
  s.textContent = CSS;
  document.head.appendChild(s);
}
function Alternador({
  rotulo,
  descricao,
  ligado = false,
  aoMudar,
  desabilitado = false,
  tamanho = "md",
  mostrarEstado = false,
  className = "",
  ...resto
}) {
  estilo();
  return /*#__PURE__*/React.createElement("label", {
    className: `pn-alt ${tamanho === "sm" ? "pn-alt--sm" : ""} ${className}`.trim(),
    "data-ligado": ligado ? "" : undefined,
    "data-desabilitado": desabilitado ? "" : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "pn-alt__trilho"
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    className: "pn-alt__nativo",
    role: "switch",
    checked: ligado,
    disabled: desabilitado,
    onChange: aoMudar
  }, resto)), /*#__PURE__*/React.createElement("span", {
    className: "pn-alt__botao",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    className: "pn-alt__pino",
    "aria-hidden": "true"
  }, ligado && /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "check",
    tamanho: 9,
    traco: 3.5
  }))), (rotulo || descricao) && /*#__PURE__*/React.createElement("span", {
    className: "pn-alt__texto"
  }, rotulo && /*#__PURE__*/React.createElement("span", {
    className: "pn-alt__rotulo"
  }, rotulo), descricao && /*#__PURE__*/React.createElement("span", {
    className: "pn-alt__descricao"
  }, descricao)), mostrarEstado && /*#__PURE__*/React.createElement("span", {
    className: "pn-alt__estado"
  }, ligado ? "Ativo" : "Inativo"));
}
Object.assign(__ds_scope, { Alternador });
})();

// components/primitivos/Botao.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-btn{display:inline-flex;align-items:center;justify-content:center;gap:var(--esp-3);height:var(--altura-controle);padding:0 var(--esp-botao-x);border-radius:var(--raio-sm);border:1px solid transparent;background:none;font:var(--texto-corpo-forte);letter-spacing:var(--letra-apertada);white-space:nowrap;cursor:pointer;user-select:none;transition:var(--transicao-toque)}
.pn-btn:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:var(--foco-deslocamento)}
.pn-btn--largura-total{width:100%}
.pn-btn--sm{height:var(--altura-controle-sm);padding:0 var(--esp-5);font:var(--texto-meta)}
.pn-btn--primario{background:var(--acao-primaria-fundo);color:var(--acao-primaria-texto)}
.pn-btn--primario:hover:not(:disabled){background:var(--acao-primaria-fundo-hover)}
.pn-btn--primario:active:not(:disabled){background:var(--acao-primaria-fundo-ativo)}
.pn-btn--secundario{background:var(--acao-secundaria-fundo);border-color:var(--acao-secundaria-borda);color:var(--acao-secundaria-texto)}
.pn-btn--secundario:hover:not(:disabled){background:var(--acao-secundaria-fundo-hover);border-color:var(--borda-forte)}
.pn-btn--secundario:active:not(:disabled){background:var(--acao-secundaria-fundo-ativo)}
.pn-btn--perigo{background:var(--acao-perigo-fundo);color:var(--acao-perigo-texto)}
.pn-btn--perigo:hover:not(:disabled){background:var(--acao-perigo-fundo-hover)}
.pn-btn--fantasma{color:var(--texto-secundario)}
.pn-btn--fantasma:hover:not(:disabled){background:var(--superficie-hover);color:var(--texto-primario)}
.pn-btn--fantasma:active:not(:disabled){background:var(--superficie-ativa)}
.pn-btn:disabled{cursor:not-allowed;background:var(--superficie-desabilitada);border-color:var(--borda-desabilitada);color:var(--texto-desabilitado)}
.pn-btn--fantasma:disabled{background:none}
.pn-giro{animation:pn-giro 800ms linear infinite}
@keyframes pn-giro{to{transform:rotate(360deg)}}
@media (prefers-reduced-motion:reduce){.pn-giro{animation-duration:2400ms}}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "botao");
  s.textContent = CSS;
  document.head.appendChild(s);
}
function Botao({
  variante = "secundario",
  tamanho = "md",
  icone,
  iconeFim,
  carregando = false,
  desabilitado = false,
  larguraTotal = false,
  tipo = "button",
  children,
  className = "",
  ...resto
}) {
  estilo();
  const px = tamanho === "sm" ? 13 : 15;
  const classes = ["pn-btn", `pn-btn--${variante}`, tamanho === "sm" ? "pn-btn--sm" : "", larguraTotal ? "pn-btn--largura-total" : "", className].filter(Boolean).join(" ");
  return /*#__PURE__*/React.createElement("button", _extends({
    type: tipo,
    className: classes,
    disabled: desabilitado || carregando,
    "aria-busy": carregando || undefined
  }, resto), carregando ? /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "loader-circle",
    tamanho: px,
    className: "pn-giro"
  }) : icone ? /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: icone,
    tamanho: px
  }) : null, children, iconeFim && !carregando ? /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: iconeFim,
    tamanho: px
  }) : null);
}
Object.assign(__ds_scope, { Botao });
})();

// components/feedback/Estado.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-estado{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:var(--esp-4);padding:var(--esp-11) var(--esp-8);text-align:center;color:var(--texto-terciario)}
.pn-estado--caixa{background:var(--superficie-painel);border:1px solid var(--borda-sutil);border-radius:var(--raio-md)}
.pn-estado__icone{display:flex;align-items:center;justify-content:center;width:44px;height:44px;border-radius:var(--raio-pilula);background:var(--superficie-afundada);color:var(--borda-forte)}
.pn-estado[data-tipo=erro] .pn-estado__icone{background:var(--erro-superficie);color:var(--erro-solido)}
.pn-estado[data-tipo=carregando] .pn-estado__icone{background:none;color:var(--texto-terciario)}
.pn-estado__titulo{font:var(--texto-corpo-forte);color:var(--texto-secundario)}
.pn-estado[data-tipo=erro] .pn-estado__titulo{color:var(--erro-texto)}
.pn-estado__descricao{max-width:44ch;font:var(--texto-corpo-denso);color:var(--texto-terciario);text-wrap:pretty}
.pn-estado__acoes{display:flex;gap:var(--esp-entre-controles);margin-top:var(--esp-2)}
.pn-estado--compacto{padding:var(--esp-8) var(--esp-6);gap:var(--esp-3)}
.pn-estado--compacto .pn-estado__icone{width:32px;height:32px}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "estado");
  s.textContent = CSS;
  document.head.appendChild(s);
}
const PADRAO = {
  vazio: {
    icone: "inbox",
    titulo: "Nada por aqui",
    descricao: "Nenhum resultado para os filtros atuais."
  },
  carregando: {
    icone: "loader-circle",
    titulo: "Carregando",
    descricao: null
  },
  erro: {
    icone: "circle-alert",
    titulo: "Não foi possível carregar",
    descricao: "Tente de novo. Se persistir, avise a operação."
  }
};
function Estado({
  tipo = "vazio",
  icone,
  titulo,
  descricao,
  acaoPrincipal,
  aoAcaoPrincipal,
  acaoSecundaria,
  aoAcaoSecundaria,
  compacto = false,
  emCaixa = false,
  className = "",
  ...resto
}) {
  estilo();
  const p = PADRAO[tipo] || PADRAO.vazio;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `pn-estado ${emCaixa ? "pn-estado--caixa" : ""} ${compacto ? "pn-estado--compacto" : ""} ${className}`.trim(),
    "data-tipo": tipo,
    role: tipo === "erro" ? "alert" : "status",
    "aria-busy": tipo === "carregando" || undefined
  }, resto), /*#__PURE__*/React.createElement("span", {
    className: "pn-estado__icone"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: icone || p.icone,
    tamanho: compacto ? 18 : 22,
    traco: 1.75,
    className: tipo === "carregando" ? "pn-giro" : undefined
  })), /*#__PURE__*/React.createElement("span", {
    className: "pn-estado__titulo"
  }, titulo || p.titulo), (descricao ?? p.descricao) && /*#__PURE__*/React.createElement("span", {
    className: "pn-estado__descricao"
  }, descricao ?? p.descricao), (acaoPrincipal || acaoSecundaria) && /*#__PURE__*/React.createElement("span", {
    className: "pn-estado__acoes"
  }, acaoSecundaria && /*#__PURE__*/React.createElement(__ds_scope.Botao, {
    variante: "fantasma",
    tamanho: "sm",
    onClick: aoAcaoSecundaria
  }, acaoSecundaria), acaoPrincipal && /*#__PURE__*/React.createElement(__ds_scope.Botao, {
    variante: tipo === "erro" ? "secundario" : "primario",
    tamanho: "sm",
    icone: tipo === "erro" ? "refresh-cw" : undefined,
    onClick: aoAcaoPrincipal
  }, acaoPrincipal)));
}
Object.assign(__ds_scope, { Estado });
})();

// components/primitivos/BotaoIcone.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-bi{display:inline-flex;align-items:center;justify-content:center;width:var(--altura-controle);height:var(--altura-controle);border-radius:var(--raio-sm);border:1px solid transparent;background:none;color:var(--texto-secundario);cursor:pointer;transition:var(--transicao-toque)}
.pn-bi:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:var(--foco-deslocamento)}
.pn-bi--sm{width:var(--altura-controle-sm);height:var(--altura-controle-sm)}
.pn-bi--fantasma:hover:not(:disabled){background:var(--superficie-hover);color:var(--texto-primario)}
.pn-bi--fantasma:active:not(:disabled){background:var(--superficie-ativa)}
.pn-bi--secundario{background:var(--acao-secundaria-fundo);border-color:var(--acao-secundaria-borda);color:var(--texto-primario)}
.pn-bi--secundario:hover:not(:disabled){background:var(--acao-secundaria-fundo-hover);border-color:var(--borda-forte)}
.pn-bi--primario{background:var(--acao-primaria-fundo);color:var(--acao-primaria-texto)}
.pn-bi--primario:hover:not(:disabled){background:var(--acao-primaria-fundo-hover)}
.pn-bi--perigo{color:var(--erro-texto)}
.pn-bi--perigo:hover:not(:disabled){background:var(--erro-superficie)}
.pn-bi[data-ativo="true"]{background:var(--superficie-selecionada);color:var(--texto-link);border-color:transparent}
.pn-bi:disabled{cursor:not-allowed;color:var(--texto-desabilitado);background:none;border-color:transparent}
.pn-bi--secundario:disabled{background:var(--superficie-desabilitada);border-color:var(--borda-desabilitada)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "botao-icone");
  s.textContent = CSS;
  document.head.appendChild(s);
}
function BotaoIcone({
  icone,
  rotulo,
  variante = "fantasma",
  tamanho = "md",
  ativo = false,
  carregando = false,
  desabilitado = false,
  tipo = "button",
  className = "",
  ...resto
}) {
  estilo();
  const px = tamanho === "sm" ? 14 : 16;
  const classes = ["pn-bi", `pn-bi--${variante}`, tamanho === "sm" ? "pn-bi--sm" : "", className].filter(Boolean).join(" ");
  return /*#__PURE__*/React.createElement("button", _extends({
    type: tipo,
    className: classes,
    title: rotulo,
    "aria-label": rotulo,
    "aria-pressed": ativo || undefined,
    "data-ativo": ativo || undefined,
    disabled: desabilitado || carregando,
    "aria-busy": carregando || undefined
  }, resto), /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: carregando ? "loader-circle" : icone,
    tamanho: px,
    className: carregando ? "pn-giro" : undefined
  }));
}
Object.assign(__ds_scope, { BotaoIcone });
})();

// components/feedback/Modal.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-modal__fundo{position:fixed;inset:0;z-index:60;display:flex;align-items:center;justify-content:center;padding:var(--esp-9);background:var(--sobreposicao-modal);animation:pn-aparecer var(--dur-rapida) var(--curva-padrao)}
.pn-modal{display:flex;flex-direction:column;width:100%;max-width:480px;max-height:100%;background:var(--superficie-sobreposta);border:1px solid var(--borda-padrao);border-radius:var(--raio-lg);box-shadow:var(--elev-4);animation:pn-subir var(--dur-padrao) var(--curva-padrao)}
.pn-modal--sm{max-width:380px}
.pn-modal--lg{max-width:720px}
@keyframes pn-aparecer{from{opacity:0}to{opacity:1}}
@keyframes pn-subir{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
@media (prefers-reduced-motion:reduce){.pn-modal__fundo,.pn-modal{animation:none}}
.pn-modal__topo{display:flex;align-items:flex-start;gap:var(--esp-5);padding:var(--esp-7) var(--esp-7) var(--esp-5)}
.pn-modal__marca{display:flex;align-items:center;justify-content:center;flex:none;width:32px;height:32px;border-radius:var(--raio-sm);background:var(--erro-superficie);color:var(--erro-solido)}
.pn-modal__textos{display:flex;flex-direction:column;gap:var(--esp-2);min-width:0;flex:1}
.pn-modal__titulo{font:var(--texto-titulo-secao);color:var(--texto-primario);text-wrap:pretty}
.pn-modal__descricao{font:var(--texto-corpo-denso);color:var(--texto-secundario);text-wrap:pretty}
.pn-modal__corpo{padding:0 var(--esp-7);overflow:auto;font:var(--texto-corpo)}
.pn-modal__corpo:empty{display:none}
.pn-modal__rodape{display:flex;align-items:center;justify-content:flex-end;gap:var(--esp-entre-controles);padding:var(--esp-7);margin-top:var(--esp-2)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "modal");
  s.textContent = CSS;
  document.head.appendChild(s);
}
function Modal({
  aberto = false,
  aoFechar,
  titulo,
  descricao,
  perigo = false,
  tamanho = "md",
  acoes,
  children,
  className = "",
  ...resto
}) {
  estilo();
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (!aberto) return;
    const t = e => {
      if (e.key === "Escape" && aoFechar) aoFechar();
    };
    document.addEventListener("keydown", t);
    ref.current?.focus();
    return () => document.removeEventListener("keydown", t);
  }, [aberto, aoFechar]);
  if (!aberto) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "pn-modal__fundo",
    onMouseDown: e => {
      if (e.target === e.currentTarget && aoFechar) aoFechar();
    }
  }, /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    tabIndex: -1,
    role: "dialog",
    "aria-modal": "true",
    "aria-label": titulo,
    className: `pn-modal ${tamanho === "sm" ? "pn-modal--sm" : tamanho === "lg" ? "pn-modal--lg" : ""} ${className}`.trim()
  }, resto), /*#__PURE__*/React.createElement("div", {
    className: "pn-modal__topo"
  }, perigo && /*#__PURE__*/React.createElement("span", {
    className: "pn-modal__marca"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "triangle-alert",
    tamanho: 17
  })), /*#__PURE__*/React.createElement("div", {
    className: "pn-modal__textos"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "pn-modal__titulo"
  }, titulo), descricao && /*#__PURE__*/React.createElement("p", {
    className: "pn-modal__descricao"
  }, descricao)), aoFechar && /*#__PURE__*/React.createElement(__ds_scope.BotaoIcone, {
    icone: "x",
    rotulo: "Fechar",
    tamanho: "sm",
    onClick: aoFechar
  })), /*#__PURE__*/React.createElement("div", {
    className: "pn-modal__corpo"
  }, children), acoes && /*#__PURE__*/React.createElement("div", {
    className: "pn-modal__rodape"
  }, acoes)));
}
Object.assign(__ds_scope, { Modal });
})();

// components/feedback/Notificacao.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-nota{display:flex;align-items:flex-start;gap:var(--esp-4);width:100%;max-width:400px;padding:var(--esp-5) var(--esp-5) var(--esp-5) var(--esp-6);background:var(--superficie-sobreposta);border:1px solid var(--borda-padrao);border-left-width:3px;border-radius:var(--raio-sm);box-shadow:var(--elev-3);animation:pn-nota-entrar var(--dur-padrao) var(--curva-padrao)}
@keyframes pn-nota-entrar{from{opacity:0;transform:translateX(12px)}to{opacity:1;transform:none}}
@media (prefers-reduced-motion:reduce){.pn-nota{animation:none}}
.pn-nota[data-tom=sucesso]{border-left-color:var(--sucesso-solido)}
.pn-nota[data-tom=erro]{border-left-color:var(--erro-solido)}
.pn-nota[data-tom=atencao]{border-left-color:var(--atencao-solido)}
.pn-nota[data-tom=info]{border-left-color:var(--info-solido)}
.pn-nota[data-tom=neutro]{border-left-color:var(--neutro-solido)}
.pn-nota__icone{flex:none;margin-top:1px}
.pn-nota[data-tom=sucesso] .pn-nota__icone{color:var(--sucesso-texto)}
.pn-nota[data-tom=erro] .pn-nota__icone{color:var(--erro-texto)}
.pn-nota[data-tom=atencao] .pn-nota__icone{color:var(--atencao-texto)}
.pn-nota[data-tom=info] .pn-nota__icone{color:var(--info-texto)}
.pn-nota[data-tom=neutro] .pn-nota__icone{color:var(--texto-secundario)}
.pn-nota__corpo{display:flex;flex-direction:column;gap:2px;flex:1;min-width:0}
.pn-nota__titulo{font:var(--texto-corpo-forte);color:var(--texto-primario);text-wrap:pretty}
.pn-nota__descricao{font:var(--texto-corpo-denso);color:var(--texto-secundario);text-wrap:pretty}
.pn-nota__acao{align-self:flex-start;margin-top:var(--esp-2);padding:0;border:0;background:none;font:var(--texto-meta);color:var(--texto-link);cursor:pointer;text-decoration:underline;text-underline-offset:2px}
.pn-nota__acao:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:2px;border-radius:var(--raio-xs)}
.pn-pilha{position:fixed;z-index:70;display:flex;flex-direction:column;gap:var(--esp-4);pointer-events:none}
.pn-pilha > *{pointer-events:auto}
.pn-pilha[data-posicao="baixo-direita"]{right:var(--esp-8);bottom:var(--esp-8)}
.pn-pilha[data-posicao="cima-direita"]{right:var(--esp-8);top:var(--esp-8)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "notificacao");
  s.textContent = CSS;
  document.head.appendChild(s);
}
const ICONE = {
  sucesso: "circle-check",
  erro: "circle-x",
  atencao: "triangle-alert",
  info: "info",
  neutro: "message-square"
};
function Notificacao({
  tom = "neutro",
  titulo,
  descricao,
  acao,
  aoAcao,
  aoFechar,
  className = "",
  ...resto
}) {
  estilo();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `pn-nota ${className}`.trim(),
    "data-tom": tom,
    role: tom === "erro" ? "alert" : "status"
  }, resto), /*#__PURE__*/React.createElement("span", {
    className: "pn-nota__icone"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: ICONE[tom] || ICONE.neutro,
    tamanho: 16
  })), /*#__PURE__*/React.createElement("span", {
    className: "pn-nota__corpo"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pn-nota__titulo"
  }, titulo), descricao && /*#__PURE__*/React.createElement("span", {
    className: "pn-nota__descricao"
  }, descricao), acao && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "pn-nota__acao",
    onClick: aoAcao
  }, acao)), aoFechar && /*#__PURE__*/React.createElement(__ds_scope.BotaoIcone, {
    icone: "x",
    rotulo: "Dispensar",
    tamanho: "sm",
    onClick: aoFechar
  }));
}
function PilhaNotificacoes({
  posicao = "baixo-direita",
  children,
  className = "",
  ...resto
}) {
  estilo();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `pn-pilha ${className}`.trim(),
    "data-posicao": posicao,
    "aria-live": "polite"
  }, resto), children);
}
Object.assign(__ds_scope, { Notificacao, PilhaNotificacoes });
})();

// components/feedback/PainelLateral.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-lateral{display:flex;flex-direction:column;width:var(--largura-painel-lateral);max-width:100%;height:100%;background:var(--superficie-painel);border-left:1px solid var(--borda-padrao)}
.pn-lateral--esquerda{border-left:0;border-right:1px solid var(--borda-padrao)}
.pn-lateral--flutuante{position:fixed;top:0;bottom:0;right:0;z-index:50;box-shadow:var(--elev-4);animation:pn-lateral-entrar var(--dur-lenta) var(--curva-padrao)}
.pn-lateral--flutuante.pn-lateral--esquerda{right:auto;left:0;animation-name:pn-lateral-entrar-esq}
@keyframes pn-lateral-entrar{from{transform:translateX(16px);opacity:0}to{transform:none;opacity:1}}
@keyframes pn-lateral-entrar-esq{from{transform:translateX(-16px);opacity:0}to{transform:none;opacity:1}}
@media (prefers-reduced-motion:reduce){.pn-lateral--flutuante{animation:none}}
.pn-lateral__topo{display:flex;align-items:flex-start;gap:var(--esp-4);min-height:var(--altura-cabecalho);padding:var(--esp-5) var(--esp-6);border-bottom:1px solid var(--borda-sutil)}
.pn-lateral__textos{display:flex;flex-direction:column;gap:1px;flex:1;min-width:0}
.pn-lateral__titulo{font:var(--texto-titulo-secao);color:var(--texto-primario);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.pn-lateral__subtitulo{font:var(--texto-legenda);color:var(--texto-terciario)}
.pn-lateral__corpo{flex:1;min-height:0;overflow:auto;padding:var(--esp-6)}
.pn-lateral__rodape{display:flex;align-items:center;justify-content:flex-end;gap:var(--esp-entre-controles);padding:var(--esp-5) var(--esp-6);border-top:1px solid var(--borda-sutil);background:var(--superficie-painel)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "painel-lateral");
  s.textContent = CSS;
  document.head.appendChild(s);
}
function PainelLateral({
  aberto = true,
  aoFechar,
  titulo,
  subtitulo,
  lado = "direita",
  flutuante = false,
  largura,
  rodape,
  acoes,
  children,
  className = "",
  ...resto
}) {
  estilo();
  if (!aberto) return null;
  return /*#__PURE__*/React.createElement("aside", _extends({
    className: `pn-lateral ${lado === "esquerda" ? "pn-lateral--esquerda" : ""} ${flutuante ? "pn-lateral--flutuante" : ""} ${className}`.trim(),
    style: largura ? {
      width: largura
    } : undefined,
    "aria-label": titulo
  }, resto), /*#__PURE__*/React.createElement("div", {
    className: "pn-lateral__topo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pn-lateral__textos"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pn-lateral__titulo"
  }, titulo), subtitulo && /*#__PURE__*/React.createElement("span", {
    className: "pn-lateral__subtitulo"
  }, subtitulo)), acoes, aoFechar && /*#__PURE__*/React.createElement(__ds_scope.BotaoIcone, {
    icone: "panel-right-close",
    rotulo: "Fechar painel",
    tamanho: "sm",
    onClick: aoFechar
  })), /*#__PURE__*/React.createElement("div", {
    className: "pn-lateral__corpo"
  }, children), rodape && /*#__PURE__*/React.createElement("div", {
    className: "pn-lateral__rodape"
  }, rodape));
}
Object.assign(__ds_scope, { PainelLateral });
})();

// components/primitivos/Caixa.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-caixa{display:inline-flex;align-items:flex-start;gap:var(--esp-4);cursor:pointer;font:var(--texto-corpo);color:var(--texto-primario)}
.pn-caixa[data-desabilitado]{cursor:not-allowed;color:var(--texto-desabilitado)}
.pn-caixa__marca{position:relative;flex:none;display:flex;align-items:center;justify-content:center;width:16px;height:16px;margin-top:2px;border:1px solid var(--borda-interativa);border-radius:var(--raio-xs);background:var(--superficie-painel);color:transparent;transition:var(--transicao-toque)}
.pn-caixa:hover:not([data-desabilitado]) .pn-caixa__marca{border-color:var(--acao-primaria-fundo)}
.pn-caixa__nativo{position:absolute;inset:0;opacity:0;margin:0;cursor:inherit}
.pn-caixa__nativo:focus-visible + .pn-caixa__glifo{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:3px;border-radius:var(--raio-xs)}
.pn-caixa__glifo{display:flex;align-items:center;justify-content:center;pointer-events:none}
.pn-caixa[data-marcado] .pn-caixa__marca,.pn-caixa[data-indeterminado] .pn-caixa__marca{background:var(--acao-primaria-fundo);border-color:var(--acao-primaria-fundo);color:var(--acao-primaria-texto)}
.pn-caixa[data-desabilitado] .pn-caixa__marca{background:var(--superficie-desabilitada);border-color:var(--borda-desabilitada);color:var(--texto-desabilitado)}
.pn-caixa[data-desabilitado][data-marcado] .pn-caixa__marca{background:var(--borda-desabilitada);color:var(--texto-desabilitado)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "caixa");
  s.textContent = CSS;
  document.head.appendChild(s);
}
function Caixa({
  rotulo,
  marcado = false,
  indeterminado = false,
  aoMudar,
  desabilitado = false,
  className = "",
  ...resto
}) {
  estilo();
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminado;
  }, [indeterminado]);
  return /*#__PURE__*/React.createElement("label", {
    className: `pn-caixa ${className}`.trim(),
    "data-marcado": marcado ? "" : undefined,
    "data-indeterminado": indeterminado ? "" : undefined,
    "data-desabilitado": desabilitado ? "" : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "pn-caixa__marca"
  }, /*#__PURE__*/React.createElement("input", _extends({
    ref: ref,
    type: "checkbox",
    className: "pn-caixa__nativo",
    checked: marcado,
    disabled: desabilitado,
    onChange: aoMudar,
    "aria-label": !rotulo ? "Selecionar" : undefined
  }, resto)), /*#__PURE__*/React.createElement("span", {
    className: "pn-caixa__glifo",
    "aria-hidden": "true"
  }, indeterminado ? /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "minus",
    tamanho: 11,
    traco: 3
  }) : marcado ? /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "check",
    tamanho: 11,
    traco: 3
  }) : null)), rotulo && /*#__PURE__*/React.createElement("span", null, rotulo));
}
Object.assign(__ds_scope, { Caixa });
})();

// components/dados/TabelaDensa.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-tabela{width:100%;overflow:auto;background:var(--superficie-painel);border:1px solid var(--borda-sutil);border-radius:var(--raio-md)}
.pn-tabela table{width:100%;border-collapse:separate;border-spacing:0;font:var(--texto-corpo-denso);font-variant-numeric:tabular-nums}
.pn-tabela thead th{position:sticky;top:0;z-index:1;background:var(--superficie-panel,var(--superficie-painel));border-bottom:1px solid var(--borda-padrao);padding:0;text-align:left;font:var(--texto-meta);color:var(--texto-secundario);white-space:nowrap}
.pn-tabela__cabeca{display:flex;align-items:center;gap:var(--esp-2);width:100%;height:var(--altura-linha-tabela);padding:0 var(--esp-5);border:0;background:none;font:inherit;color:inherit;text-align:inherit}
.pn-tabela__cabeca--ordenavel{cursor:pointer}
.pn-tabela__cabeca--ordenavel:hover{background:var(--superficie-hover);color:var(--texto-primario)}
.pn-tabela__cabeca:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:calc(var(--foco-largura) * -1)}
.pn-tabela__cabeca[data-alinhamento=direita]{justify-content:flex-end}
.pn-tabela__seta{flex:none;opacity:.35}
.pn-tabela__cabeca[data-ativa] .pn-tabela__seta{opacity:1;color:var(--texto-link)}
.pn-tabela__funil{display:flex;align-items:center;justify-content:center;flex:none;width:18px;height:18px;margin-right:var(--esp-3);padding:0;border:0;border-radius:var(--raio-xs);background:none;color:var(--texto-terciario);cursor:pointer}
.pn-tabela__funil:hover{background:var(--superficie-hover);color:var(--texto-primario)}
.pn-tabela__funil[data-ativo]{color:var(--texto-link);background:var(--superficie-selecionada)}
.pn-tabela__funil:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:1px}
.pn-tabela__linha-filtro th{position:sticky;top:var(--altura-linha-tabela);z-index:1;background:var(--superficie-afundada);border-bottom:1px solid var(--borda-sutil);padding:var(--esp-2) var(--esp-3)}
.pn-tabela__filtro{width:100%;height:24px;padding:0 var(--esp-3);border:1px solid var(--borda-padrao);border-radius:var(--raio-xs);background:var(--superficie-painel);font:var(--texto-legenda);color:var(--texto-primario)}
.pn-tabela__filtro:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:1px;border-color:var(--foco-anel)}
.pn-tabela tbody td{height:var(--altura-linha-tabela);padding:0 var(--esp-5);border-bottom:1px solid var(--borda-sutil);color:var(--texto-primario);vertical-align:middle}
.pn-tabela tbody td[data-alinhamento=direita]{text-align:right}
.pn-tabela tbody tr:last-child td{border-bottom:0}
.pn-tabela tbody tr[data-clicavel]{cursor:pointer}
.pn-tabela tbody tr:hover td{background:var(--superficie-hover)}
.pn-tabela tbody tr[data-selecionada] td{background:var(--superficie-selecionada)}
.pn-tabela tbody tr:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:calc(var(--foco-largura) * -1)}
.pn-tabela__sel{width:36px;padding-left:var(--esp-5);padding-right:0}
.pn-tabela__estado{padding:var(--esp-10) var(--esp-7);text-align:center;color:var(--texto-terciario);font:var(--texto-corpo)}
.pn-tabela__estado-icone{display:flex;justify-content:center;margin-bottom:var(--esp-4);color:var(--borda-forte)}
.pn-tabela__esqueleto{height:9px;border-radius:var(--raio-xs);background:var(--superficie-afundada);animation:pn-pulsar var(--dur-pulso) var(--curva-linear) infinite}
@media (prefers-reduced-motion:reduce){.pn-tabela__esqueleto{animation:none}}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "tabela-densa");
  s.textContent = CSS;
  document.head.appendChild(s);
}
function TabelaDensa({
  colunas = [],
  linhas = [],
  ordenacao,
  aoOrdenar,
  filtros = {},
  aoFiltrar,
  selecionaveis = false,
  selecionadas = [],
  aoSelecionar,
  aoClicarLinha,
  carregando = false,
  erro,
  vazio,
  rotulo = "Tabela",
  className = "",
  ...resto
}) {
  estilo();
  const temFiltravel = colunas.some(c => c.filtravel);
  const [mostrarFiltros, setMostrarFiltros] = React.useState(false);
  const todas = linhas.length > 0 && selecionadas.length === linhas.length;
  const colSpan = colunas.length + (selecionaveis ? 1 : 0);
  const alternar = id => {
    if (!aoSelecionar) return;
    aoSelecionar(selecionadas.includes(id) ? selecionadas.filter(x => x !== id) : [...selecionadas, id]);
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `pn-tabela ${className}`.trim()
  }, resto), /*#__PURE__*/React.createElement("table", {
    "aria-label": rotulo
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, selecionaveis && /*#__PURE__*/React.createElement("th", {
    className: "pn-tabela__sel"
  }, /*#__PURE__*/React.createElement(__ds_scope.Caixa, {
    marcado: todas,
    indeterminado: !todas && selecionadas.length > 0,
    aoMudar: () => aoSelecionar && aoSelecionar(todas ? [] : linhas.map(l => l.id))
  })), colunas.map(c => {
    const ativa = ordenacao && ordenacao.chave === c.chave;
    const seta = ativa ? ordenacao.direcao === "asc" ? "arrow-up" : "arrow-down" : "arrow-up-down";
    return /*#__PURE__*/React.createElement("th", {
      key: c.chave,
      style: {
        width: c.largura
      },
      "aria-sort": ativa ? ordenacao.direcao === "asc" ? "ascending" : "descending" : undefined
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, c.ordenavel ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pn-tabela__cabeca pn-tabela__cabeca--ordenavel",
      "data-alinhamento": c.alinhamento,
      "data-ativa": ativa ? "" : undefined,
      onClick: () => aoOrdenar && aoOrdenar(c.chave)
    }, /*#__PURE__*/React.createElement("span", null, c.rotulo), /*#__PURE__*/React.createElement(__ds_scope.Icone, {
      nome: seta,
      tamanho: 12,
      className: "pn-tabela__seta"
    })) : /*#__PURE__*/React.createElement("span", {
      className: "pn-tabela__cabeca",
      "data-alinhamento": c.alinhamento
    }, c.rotulo), c.filtravel && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pn-tabela__funil",
      "data-ativo": filtros[c.chave] ? "" : undefined,
      "aria-label": `Filtrar por ${c.rotulo}`,
      "aria-expanded": mostrarFiltros,
      onClick: () => setMostrarFiltros(v => !v)
    }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
      nome: "list-filter",
      tamanho: 12
    }))));
  })), temFiltravel && mostrarFiltros && /*#__PURE__*/React.createElement("tr", {
    className: "pn-tabela__linha-filtro"
  }, selecionaveis && /*#__PURE__*/React.createElement("th", null), colunas.map(c => /*#__PURE__*/React.createElement("th", {
    key: c.chave
  }, c.filtravel && /*#__PURE__*/React.createElement("input", {
    className: "pn-tabela__filtro",
    value: filtros[c.chave] || "",
    placeholder: c.rotulo,
    "aria-label": `Filtrar ${c.rotulo}`,
    onChange: e => aoFiltrar && aoFiltrar(c.chave, e.target.value)
  }))))), /*#__PURE__*/React.createElement("tbody", null, carregando ? Array.from({
    length: 6
  }).map((_, i) => /*#__PURE__*/React.createElement("tr", {
    key: i
  }, selecionaveis && /*#__PURE__*/React.createElement("td", {
    className: "pn-tabela__sel"
  }), colunas.map((c, j) => /*#__PURE__*/React.createElement("td", {
    key: c.chave
  }, /*#__PURE__*/React.createElement("div", {
    className: "pn-tabela__esqueleto",
    style: {
      width: `${[70, 45, 55, 35, 60][(i + j) % 5]}%`
    }
  }))))) : erro ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: colSpan,
    className: "pn-tabela__estado"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pn-tabela__estado-icone",
    style: {
      color: "var(--erro-solido)"
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "circle-alert",
    tamanho: 22
  })), erro)) : linhas.length === 0 ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: colSpan,
    className: "pn-tabela__estado"
  }, vazio || /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pn-tabela__estado-icone"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "inbox",
    tamanho: 22,
    traco: 1.5
  })), "Nenhum resultado para os filtros atuais."))) : linhas.map(l => /*#__PURE__*/React.createElement("tr", {
    key: l.id,
    "data-selecionada": selecionadas.includes(l.id) ? "" : undefined,
    "data-clicavel": aoClicarLinha ? "" : undefined,
    tabIndex: aoClicarLinha ? 0 : undefined,
    onClick: aoClicarLinha ? () => aoClicarLinha(l) : undefined,
    onKeyDown: aoClicarLinha ? e => {
      if (e.key === "Enter") aoClicarLinha(l);
    } : undefined
  }, selecionaveis && /*#__PURE__*/React.createElement("td", {
    className: "pn-tabela__sel",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement(__ds_scope.Caixa, {
    marcado: selecionadas.includes(l.id),
    aoMudar: () => alternar(l.id)
  })), colunas.map(c => /*#__PURE__*/React.createElement("td", {
    key: c.chave,
    "data-alinhamento": c.alinhamento
  }, c.render ? c.render(l) : l[c.chave])))))));
}
Object.assign(__ds_scope, { TabelaDensa });
})();

// components/primitivos/Campo.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-campo{display:flex;flex-direction:column;gap:var(--esp-2);min-width:0}
.pn-campo__rotulo{font:var(--texto-meta);color:var(--texto-secundario)}
.pn-campo__obrigatorio{color:var(--erro-texto);margin-left:2px}
.pn-campo__caixa{display:flex;align-items:center;gap:var(--esp-3);min-height:var(--altura-controle);padding:0 var(--esp-campo-x);background:var(--superficie-painel);border:1px solid var(--borda-padrao);border-radius:var(--raio-sm);color:var(--texto-terciario);transition:var(--transicao-toque)}
.pn-campo__caixa:hover:not([data-desabilitado]){border-color:var(--borda-interativa)}
.pn-campo__caixa:focus-within{border-color:var(--foco-anel);outline:var(--foco-largura) solid var(--foco-anel);outline-offset:1px}
.pn-campo__caixa[data-erro]{border-color:var(--erro-solido);background:var(--erro-superficie)}
.pn-campo__caixa[data-desabilitado]{background:var(--superficie-desabilitada);border-color:var(--borda-desabilitada);color:var(--texto-desabilitado);cursor:not-allowed}
.pn-campo__caixa[data-multilinha]{align-items:flex-start;padding-top:var(--esp-3);padding-bottom:var(--esp-3)}
.pn-campo__entrada{flex:1;min-width:0;width:100%;border:0;outline:0;background:none;font:var(--texto-corpo);color:var(--texto-primario);padding:var(--esp-3) 0}
.pn-campo__caixa[data-multilinha] .pn-campo__entrada{padding:0;resize:vertical;line-height:20px}
.pn-campo__entrada::placeholder{color:var(--texto-terciario)}
.pn-campo__entrada:disabled{color:var(--texto-desabilitado);cursor:not-allowed;-webkit-text-fill-color:var(--texto-desabilitado)}
.pn-campo__auxiliar{display:flex;align-items:flex-start;gap:var(--esp-2);font:var(--texto-legenda);color:var(--texto-terciario)}
.pn-campo__auxiliar[data-erro]{color:var(--erro-texto)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "campo");
  s.textContent = CSS;
  document.head.appendChild(s);
}
let seq = 0;
function Campo({
  rotulo,
  valor,
  aoMudar,
  placeholder,
  tipo = "text",
  icone,
  dica,
  erro,
  obrigatorio = false,
  desabilitado = false,
  somenteLeitura = false,
  multilinha = false,
  linhas = 3,
  id,
  className = "",
  ...resto
}) {
  estilo();
  const idRef = React.useRef(id || `pn-campo-${++seq}`);
  const idCampo = id || idRef.current;
  const idAux = `${idCampo}-aux`;
  const Entrada = multilinha ? "textarea" : "input";
  return /*#__PURE__*/React.createElement("div", {
    className: `pn-campo ${className}`.trim()
  }, rotulo && /*#__PURE__*/React.createElement("label", {
    className: "pn-campo__rotulo",
    htmlFor: idCampo
  }, rotulo, obrigatorio && /*#__PURE__*/React.createElement("span", {
    className: "pn-campo__obrigatorio",
    "aria-hidden": "true"
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: "pn-campo__caixa",
    "data-erro": erro ? "" : undefined,
    "data-desabilitado": desabilitado ? "" : undefined,
    "data-multilinha": multilinha ? "" : undefined
  }, icone && /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: icone,
    tamanho: 15
  }), /*#__PURE__*/React.createElement(Entrada, _extends({
    id: idCampo,
    className: "pn-campo__entrada",
    type: multilinha ? undefined : tipo,
    rows: multilinha ? linhas : undefined,
    value: valor,
    placeholder: placeholder,
    disabled: desabilitado,
    readOnly: somenteLeitura,
    required: obrigatorio,
    "aria-invalid": erro ? true : undefined,
    "aria-describedby": dica || erro ? idAux : undefined,
    onChange: aoMudar
  }, resto))), (erro || dica) && /*#__PURE__*/React.createElement("div", {
    className: "pn-campo__auxiliar",
    id: idAux,
    "data-erro": erro ? "" : undefined
  }, erro && /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "circle-alert",
    tamanho: 13,
    style: {
      marginTop: 1
    }
  }), /*#__PURE__*/React.createElement("span", null, erro || dica)));
}
Object.assign(__ds_scope, { Campo });
})();

// components/primitivos/Selecao.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-selecao{display:flex;flex-direction:column;gap:var(--esp-2);min-width:0}
.pn-selecao__rotulo{font:var(--texto-meta);color:var(--texto-secundario)}
.pn-selecao__caixa{position:relative;display:flex;align-items:center}
.pn-selecao__nativo{appearance:none;-webkit-appearance:none;width:100%;height:var(--altura-controle);padding:0 calc(var(--esp-campo-x) + 18px) 0 var(--esp-campo-x);background:var(--superficie-painel);border:1px solid var(--borda-padrao);border-radius:var(--raio-sm);font:var(--texto-corpo);color:var(--texto-primario);cursor:pointer;transition:var(--transicao-toque)}
.pn-selecao__nativo:hover:not(:disabled){border-color:var(--borda-interativa)}
.pn-selecao__nativo:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:1px;border-color:var(--foco-anel)}
.pn-selecao__nativo[data-erro]{border-color:var(--erro-solido);background:var(--erro-superficie)}
.pn-selecao__nativo:disabled{background:var(--superficie-desabilitada);border-color:var(--borda-desabilitada);color:var(--texto-desabilitado);cursor:not-allowed}
.pn-selecao__nativo[data-vazio="true"]{color:var(--texto-terciario)}
.pn-selecao__seta{position:absolute;right:var(--esp-4);pointer-events:none;color:var(--texto-terciario)}
.pn-selecao__nativo:disabled + .pn-selecao__seta{color:var(--texto-desabilitado)}
.pn-selecao--sm .pn-selecao__nativo{height:var(--altura-controle-sm);font:var(--texto-meta);padding-left:var(--esp-4);padding-right:26px}
.pn-selecao__auxiliar{display:flex;align-items:flex-start;gap:var(--esp-2);font:var(--texto-legenda);color:var(--texto-terciario)}
.pn-selecao__auxiliar[data-erro]{color:var(--erro-texto)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "selecao");
  s.textContent = CSS;
  document.head.appendChild(s);
}
let seq = 0;
function Selecao({
  rotulo,
  valor,
  aoMudar,
  opcoes = [],
  placeholder,
  dica,
  erro,
  tamanho = "md",
  obrigatorio = false,
  desabilitado = false,
  id,
  className = "",
  ...resto
}) {
  estilo();
  const idRef = React.useRef(id || `pn-selecao-${++seq}`);
  const idCampo = id || idRef.current;
  const idAux = `${idCampo}-aux`;
  return /*#__PURE__*/React.createElement("div", {
    className: `pn-selecao ${tamanho === "sm" ? "pn-selecao--sm" : ""} ${className}`.trim()
  }, rotulo && /*#__PURE__*/React.createElement("label", {
    className: "pn-selecao__rotulo",
    htmlFor: idCampo
  }, rotulo), /*#__PURE__*/React.createElement("div", {
    className: "pn-selecao__caixa"
  }, /*#__PURE__*/React.createElement("select", _extends({
    id: idCampo,
    className: "pn-selecao__nativo",
    value: valor ?? "",
    onChange: aoMudar,
    disabled: desabilitado,
    required: obrigatorio,
    "data-erro": erro ? "" : undefined,
    "data-vazio": !valor,
    "aria-invalid": erro ? true : undefined,
    "aria-describedby": dica || erro ? idAux : undefined
  }, resto), placeholder && /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true
  }, placeholder), opcoes.map(o => /*#__PURE__*/React.createElement("option", {
    key: o.valor,
    value: o.valor,
    disabled: o.desabilitado
  }, o.rotulo))), /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "chevron-down",
    tamanho: tamanho === "sm" ? 13 : 15,
    className: "pn-selecao__seta"
  })), (erro || dica) && /*#__PURE__*/React.createElement("div", {
    className: "pn-selecao__auxiliar",
    id: idAux,
    "data-erro": erro ? "" : undefined
  }, erro && /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "circle-alert",
    tamanho: 13,
    style: {
      marginTop: 1
    }
  }), /*#__PURE__*/React.createElement("span", null, erro || dica)));
}
Object.assign(__ds_scope, { Selecao });
})();

// components/dados/BarraFiltros.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-filtros{display:flex;align-items:center;gap:var(--esp-4);flex-wrap:wrap;padding:var(--esp-5) var(--esp-gutter-painel);background:var(--superficie-painel);border-bottom:1px solid var(--borda-sutil)}
.pn-filtros__busca{flex:1;min-width:200px;max-width:360px}
.pn-filtros__grupo{display:flex;align-items:center;gap:var(--esp-3);flex-wrap:wrap}
.pn-filtros__divisor{width:1px;height:18px;background:var(--borda-padrao)}
.pn-filtros__chips{display:flex;align-items:center;gap:var(--esp-3);flex-wrap:wrap;width:100%}
.pn-chip{display:inline-flex;align-items:center;gap:var(--esp-2);height:24px;padding:0 var(--esp-2) 0 var(--esp-4);border:1px solid var(--info-borda);border-radius:var(--raio-pilula);background:var(--info-superficie);color:var(--info-texto);font:var(--texto-meta);white-space:nowrap}
.pn-chip__nome{opacity:.75}
.pn-chip__x{display:flex;align-items:center;justify-content:center;width:16px;height:16px;padding:0;border:0;border-radius:var(--raio-pilula);background:none;color:inherit;cursor:pointer}
.pn-chip__x:hover{background:rgba(0,0,0,.08)}
.pn-chip__x:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:1px}
.pn-filtros__limpar{display:inline-flex;align-items:center;gap:var(--esp-2);height:24px;padding:0 var(--esp-3);border:0;border-radius:var(--raio-sm);background:none;color:var(--texto-secundario);font:var(--texto-meta);cursor:pointer}
.pn-filtros__limpar:hover{background:var(--superficie-hover);color:var(--texto-primario)}
.pn-filtros__limpar:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:1px}
.pn-filtros__contagem{margin-left:auto;font:var(--texto-legenda);color:var(--texto-terciario);font-variant-numeric:tabular-nums;white-space:nowrap}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "barra-filtros");
  s.textContent = CSS;
  document.head.appendChild(s);
}
function BarraFiltros({
  busca,
  aoBuscar,
  aoLimparBusca,
  placeholderBusca,
  filtros = [],
  aoFiltrar,
  ativos = [],
  aoRemover,
  aoLimparTudo,
  contagem,
  children,
  className = "",
  ...resto
}) {
  estilo();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `pn-filtros ${className}`.trim(),
    role: "search"
  }, resto), /*#__PURE__*/React.createElement("div", {
    className: "pn-filtros__busca"
  }, /*#__PURE__*/React.createElement(__ds_scope.CampoBusca, {
    valor: busca,
    aoMudar: aoBuscar,
    aoLimpar: aoLimparBusca,
    placeholder: placeholderBusca,
    tamanho: "sm",
    atalho: "/"
  })), filtros.length > 0 && /*#__PURE__*/React.createElement("span", {
    className: "pn-filtros__divisor",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pn-filtros__grupo"
  }, filtros.map(f => /*#__PURE__*/React.createElement(__ds_scope.Selecao, {
    key: f.id,
    tamanho: "sm",
    valor: f.valor,
    placeholder: f.placeholder,
    opcoes: f.opcoes,
    "aria-label": f.rotulo,
    aoMudar: e => aoFiltrar && aoFiltrar(f.id, e.target.value)
  })), children), typeof contagem === "string" && /*#__PURE__*/React.createElement("span", {
    className: "pn-filtros__contagem"
  }, contagem), ativos.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "pn-filtros__chips"
  }, ativos.map(a => /*#__PURE__*/React.createElement("span", {
    className: "pn-chip",
    key: a.id
  }, /*#__PURE__*/React.createElement("span", {
    className: "pn-chip__nome"
  }, a.rotulo, ":"), a.valor, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "pn-chip__x",
    onClick: () => aoRemover && aoRemover(a.id),
    "aria-label": `Remover filtro ${a.rotulo}`
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "x",
    tamanho: 11
  })))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "pn-filtros__limpar",
    onClick: aoLimparTudo
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "filter-x",
    tamanho: 13
  }), "Limpar filtros")));
}
Object.assign(__ds_scope, { BarraFiltros });
})();

// components/sinais/IndicadorEntrega.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-entrega{display:inline-flex;align-items:center;gap:3px;font:var(--texto-micro);white-space:nowrap;font-variant-numeric:tabular-nums}
.pn-entrega[data-estado=pendente]{color:var(--entrega-pendente)}
.pn-entrega[data-estado=enviada]{color:var(--entrega-enviada)}
.pn-entrega[data-estado=falhou]{color:var(--entrega-falhou)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "entrega");
  s.textContent = CSS;
  document.head.appendChild(s);
}
const MAPA = {
  pendente: {
    icone: "clock",
    texto: "Pendente"
  },
  enviada: {
    icone: "check",
    texto: "Enviada"
  },
  falhou: {
    icone: "circle-x",
    texto: "Falhou após 3 tentativas"
  }
};
function IndicadorEntrega({
  estado = "enviada",
  comRotulo = false,
  className = "",
  ...resto
}) {
  estilo();
  const m = MAPA[estado] || MAPA.enviada;
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `pn-entrega ${className}`.trim(),
    "data-estado": estado,
    title: comRotulo ? undefined : m.texto
  }, resto), /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: m.icone,
    tamanho: 12
  }), comRotulo || estado === "falhou" ? /*#__PURE__*/React.createElement("span", null, m.texto) : /*#__PURE__*/React.createElement("span", {
    className: "apenas-leitor"
  }, m.texto));
}
Object.assign(__ds_scope, { IndicadorEntrega });
})();

// components/sinais/IndicadorPresenca.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-pres{display:inline-flex;align-items:center;gap:var(--esp-3);white-space:nowrap;font:var(--texto-legenda);color:var(--texto-terciario)}
.pn-pres__marca{display:inline-flex;align-items:center;justify-content:center;flex:none;width:14px;height:14px}
.pn-pres__ponto{width:8px;height:8px;border-radius:var(--raio-pilula)}
.pn-pres[data-presenca=disponivel] .pn-pres__ponto{background:var(--presenca-disponivel)}
.pn-pres[data-presenca=disponivel]{color:var(--sucesso-texto)}
.pn-pres[data-presenca=indisponivel] .pn-pres__ponto{background:none;border:1.5px solid var(--presenca-indisponivel)}
.pn-pres[data-presenca=digitando]{color:var(--info-texto)}
.pn-pres[data-presenca=gravando]{color:var(--erro-texto)}
.pn-pres__pontos{display:flex;align-items:flex-end;gap:2px}
.pn-pres__pontos i{width:3px;height:3px;border-radius:var(--raio-pilula);background:var(--presenca-digitando);animation:pn-pres-ponto var(--dur-pulso) var(--curva-linear) infinite}
.pn-pres__pontos i:nth-child(2){animation-delay:180ms}
.pn-pres__pontos i:nth-child(3){animation-delay:360ms}
@keyframes pn-pres-ponto{0%,70%,100%{opacity:.3;transform:translateY(0)}25%{opacity:1;transform:translateY(-3px)}}
.pn-pres__barras{display:flex;align-items:center;gap:2px;height:12px}
.pn-pres__barras i{width:2px;height:4px;border-radius:1px;background:var(--presenca-gravando);animation:pn-pres-barra var(--dur-pulso) var(--curva-linear) infinite}
.pn-pres__barras i:nth-child(2){animation-delay:200ms}
.pn-pres__barras i:nth-child(3){animation-delay:400ms}
@keyframes pn-pres-barra{0%,100%{height:4px}40%{height:11px}}
@media (prefers-reduced-motion:reduce){.pn-pres__pontos i,.pn-pres__barras i{animation:none;opacity:1}.pn-pres__barras i:nth-child(2){height:11px}}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "presenca");
  s.textContent = CSS;
  document.head.appendChild(s);
}
const ROTULOS = {
  digitando: "Digitando",
  gravando: "Gravando áudio",
  disponivel: "Disponível",
  indisponivel: "Indisponível"
};
function IndicadorPresenca({
  presenca = "indisponivel",
  comRotulo = true,
  className = "",
  ...resto
}) {
  estilo();
  const rotulo = ROTULOS[presenca] || ROTULOS.indisponivel;
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `pn-pres ${className}`.trim(),
    "data-presenca": presenca,
    title: comRotulo ? undefined : rotulo,
    "aria-live": "polite"
  }, resto), /*#__PURE__*/React.createElement("span", {
    className: "pn-pres__marca",
    "aria-hidden": "true"
  }, presenca === "digitando" ? /*#__PURE__*/React.createElement("span", {
    className: "pn-pres__pontos"
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null)) : presenca === "gravando" ? /*#__PURE__*/React.createElement("span", {
    className: "pn-pres__barras"
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null)) : /*#__PURE__*/React.createElement("span", {
    className: "pn-pres__ponto"
  })), comRotulo ? /*#__PURE__*/React.createElement("span", null, rotulo) : /*#__PURE__*/React.createElement("span", {
    className: "apenas-leitor"
  }, rotulo));
}
Object.assign(__ds_scope, { IndicadorPresenca });
})();

// components/sinais/Selo.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-selo{display:inline-flex;align-items:center;gap:var(--esp-2);max-width:100%;padding:var(--esp-selo-y) var(--esp-selo-x);border:1px solid transparent;border-radius:var(--raio-xs);font:var(--texto-meta);line-height:16px;white-space:nowrap}
.pn-selo--sm{padding:0 var(--esp-2);font:var(--texto-micro);line-height:15px;gap:3px}
.pn-selo__texto{overflow:hidden;text-overflow:ellipsis}
.pn-selo__ponto{flex:none;width:6px;height:6px;border-radius:var(--raio-pilula);background:currentColor}
.pn-selo--suave[data-tom=neutro]{background:var(--neutro-superficie);color:var(--neutro-texto);border-color:var(--neutro-borda)}
.pn-selo--suave[data-tom=sucesso]{background:var(--sucesso-superficie);color:var(--sucesso-texto);border-color:var(--sucesso-borda)}
.pn-selo--suave[data-tom=atencao]{background:var(--atencao-superficie);color:var(--atencao-texto);border-color:var(--atencao-borda)}
.pn-selo--suave[data-tom=erro]{background:var(--erro-superficie);color:var(--erro-texto);border-color:var(--erro-borda)}
.pn-selo--suave[data-tom=info]{background:var(--info-superficie);color:var(--info-texto);border-color:var(--info-borda)}
.pn-selo--suave[data-tom=ia]{background:var(--controle-ia-superficie);color:var(--controle-ia-texto);border-color:var(--controle-ia-borda)}
.pn-selo--suave[data-tom=humano]{background:var(--controle-humano-superficie);color:var(--controle-humano-texto);border-color:var(--controle-humano-borda)}
.pn-selo--solido[data-tom=neutro]{background:var(--neutro-solido);color:var(--texto-invertido)}
.pn-selo--solido[data-tom=sucesso]{background:var(--sucesso-solido);color:#fff}
.pn-selo--solido[data-tom=atencao]{background:var(--atencao-solido);color:#fff}
.pn-selo--solido[data-tom=erro]{background:var(--erro-solido);color:#fff}
.pn-selo--solido[data-tom=info]{background:var(--info-solido);color:#fff}
.pn-selo--solido[data-tom=ia]{background:var(--controle-ia-solido);color:#fff}
.pn-selo--solido[data-tom=humano]{background:var(--controle-humano-solido);color:#fff}
.pn-selo--contorno{background:none;border-color:var(--borda-padrao);color:var(--texto-secundario)}
.pn-selo--contorno[data-tom=sucesso]{border-color:var(--sucesso-borda);color:var(--sucesso-texto)}
.pn-selo--contorno[data-tom=atencao]{border-color:var(--atencao-borda);color:var(--atencao-texto)}
.pn-selo--contorno[data-tom=erro]{border-color:var(--erro-borda);color:var(--erro-texto)}
.pn-selo--contorno[data-tom=info]{border-color:var(--info-borda);color:var(--info-texto)}
.pn-selo--contorno[data-tom=ia]{border-color:var(--controle-ia-borda);color:var(--controle-ia-texto)}
.pn-selo--contorno[data-tom=humano]{border-color:var(--controle-humano-borda);color:var(--controle-humano-texto)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "selo");
  s.textContent = CSS;
  document.head.appendChild(s);
}
function Selo({
  tom = "neutro",
  variante = "suave",
  icone,
  ponto = false,
  tamanho = "md",
  children,
  className = "",
  ...resto
}) {
  estilo();
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `pn-selo pn-selo--${variante} ${tamanho === "sm" ? "pn-selo--sm" : ""} ${className}`.trim(),
    "data-tom": tom
  }, resto), ponto && /*#__PURE__*/React.createElement("span", {
    className: "pn-selo__ponto",
    "aria-hidden": "true"
  }), icone && /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: icone,
    tamanho: tamanho === "sm" ? 11 : 13
  }), /*#__PURE__*/React.createElement("span", {
    className: "pn-selo__texto"
  }, children));
}
Object.assign(__ds_scope, { Selo });
})();

// components/sinais/SeloControle.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-controle{display:inline-flex;align-items:center;gap:var(--esp-2);padding:var(--esp-selo-y) var(--esp-selo-x);border:1px solid transparent;border-radius:var(--raio-xs);font:var(--texto-meta);line-height:16px;white-space:nowrap}
.pn-controle--sm{padding:0 var(--esp-2);font:var(--texto-micro);line-height:15px;gap:3px}
.pn-controle[data-controle=ia]{background:var(--controle-ia-superficie);color:var(--controle-ia-texto);border-color:var(--controle-ia-borda)}
.pn-controle[data-controle=humano]{background:var(--controle-humano-superficie);color:var(--controle-humano-texto);border-color:var(--controle-humano-borda)}
.pn-controle__silencio{display:inline-flex;align-items:center;gap:3px;padding-left:var(--esp-2);margin-left:1px;border-left:1px solid currentColor;opacity:.85;font-variant-numeric:tabular-nums}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "controle");
  s.textContent = CSS;
  document.head.appendChild(s);
}
function SeloControle({
  controle = "ia",
  tempoRestante,
  tamanho = "sm",
  className = "",
  ...resto
}) {
  estilo();
  const humano = controle === "humano";
  const px = tamanho === "sm" ? 11 : 13;
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `pn-controle ${tamanho === "sm" ? "pn-controle--sm" : ""} ${className}`.trim(),
    "data-controle": controle
  }, resto), /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: humano ? "user-round" : "bot",
    tamanho: px
  }), /*#__PURE__*/React.createElement("span", null, humano ? "Humano" : "IA"), humano && tempoRestante && /*#__PURE__*/React.createElement("span", {
    className: "pn-controle__silencio"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "bell-off",
    tamanho: px
  }), /*#__PURE__*/React.createElement("span", null, tempoRestante), /*#__PURE__*/React.createElement("span", {
    className: "apenas-leitor"
  }, "restantes de IA silenciada")));
}
Object.assign(__ds_scope, { SeloControle });
})();

// components/sinais/SeloConversa.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const MAPA = {
  aberta: {
    tom: "neutro",
    variante: "contorno",
    icone: "message-square",
    texto: "Aberta"
  },
  encerrada: {
    tom: "neutro",
    variante: "suave",
    icone: "circle-check",
    texto: "Encerrada"
  }
};
function SeloConversa({
  estado = "aberta",
  tamanho = "sm",
  className = "",
  ...resto
}) {
  const m = MAPA[estado] || MAPA.aberta;
  return /*#__PURE__*/React.createElement(__ds_scope.Selo, _extends({
    tom: m.tom,
    variante: m.variante,
    icone: m.icone,
    tamanho: tamanho,
    className: className
  }, resto), m.texto);
}
Object.assign(__ds_scope, { SeloConversa });
})();

// components/sinais/SeloProcessamento.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-proc{display:inline-flex;align-items:center;gap:var(--esp-2);padding:0 var(--esp-2);border:1px solid transparent;border-radius:var(--raio-xs);font:var(--texto-micro);line-height:15px;white-space:nowrap}
.pn-proc[data-estado=processando]{background:var(--info-superficie);color:var(--info-texto);border-color:var(--info-borda)}
.pn-proc[data-estado=travado]{background:var(--atencao-superficie);color:var(--atencao-texto);border-color:var(--atencao-borda)}
.pn-proc[data-estado=expirou]{background:var(--atencao-superficie);color:var(--atencao-texto);border-color:var(--atencao-borda)}
.pn-proc[data-estado=falhou]{background:var(--erro-superficie);color:var(--erro-texto);border-color:var(--erro-borda)}
.pn-proc[data-estado=concluido]{background:var(--neutro-superficie);color:var(--neutro-texto);border-color:var(--neutro-borda)}
.pn-proc__detalhe{opacity:.85;font-variant-numeric:tabular-nums}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "processamento");
  s.textContent = CSS;
  document.head.appendChild(s);
}
const MAPA = {
  processando: {
    icone: "loader-circle",
    texto: "Processando",
    girando: true
  },
  travado: {
    icone: "triangle-alert",
    texto: "Travado"
  },
  expirou: {
    icone: "hourglass",
    texto: "Expirou"
  },
  falhou: {
    icone: "circle-x",
    texto: "Falhou"
  },
  concluido: {
    icone: "check",
    texto: "Concluído"
  }
};
function SeloProcessamento({
  estado = "processando",
  detalhe,
  className = "",
  ...resto
}) {
  estilo();
  const m = MAPA[estado] || MAPA.processando;
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `pn-proc ${className}`.trim(),
    "data-estado": estado,
    role: "status"
  }, resto), /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: m.icone,
    tamanho: 11,
    className: m.girando ? "pn-giro" : undefined
  }), /*#__PURE__*/React.createElement("span", null, m.texto), detalhe && /*#__PURE__*/React.createElement("span", {
    className: "pn-proc__detalhe"
  }, "\xB7 ", detalhe));
}
Object.assign(__ds_scope, { SeloProcessamento });
})();

// components/conversa/BolhaMensagem.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-msg{display:flex;flex-direction:column;gap:var(--esp-1);max-width:var(--largura-max-bolha);min-width:0}
.pn-msg--cliente{align-self:flex-start;align-items:flex-start}
.pn-msg--assistente{align-self:flex-end;align-items:flex-end}
.pn-msg--sistema{align-self:stretch;align-items:stretch;max-width:100%}
.pn-msg__autor{display:flex;align-items:center;gap:var(--esp-2);font:var(--texto-micro);color:var(--texto-terciario);padding:0 var(--esp-1)}
.pn-msg__balao{position:relative;padding:var(--esp-4) var(--esp-6);border:1px solid;border-radius:var(--raio-md);font:var(--texto-corpo);text-wrap:pretty;overflow-wrap:anywhere}
.pn-msg--cliente .pn-msg__balao{background:var(--origem-cliente-superficie);border-color:var(--origem-cliente-borda);color:var(--origem-cliente-texto);border-bottom-left-radius:var(--raio-bolha-canto-origem)}
.pn-msg--assistente .pn-msg__balao{background:var(--origem-assistente-superficie);border-color:var(--origem-assistente-borda);color:var(--origem-assistente-texto);border-bottom-right-radius:var(--raio-bolha-canto-origem)}
.pn-msg--sistema .pn-msg__balao{background:var(--origem-sistema-superficie);border:1px dashed var(--origem-sistema-borda);color:var(--origem-sistema-texto);border-radius:var(--raio-sm);font:var(--texto-codigo);padding:var(--esp-4) var(--esp-5)}
.pn-msg--sistema .pn-msg__autor{color:var(--texto-terciario);font-family:var(--fonte-mono);letter-spacing:var(--letra-normal)}
.pn-msg__citacao{display:flex;flex-direction:column;gap:1px;margin-bottom:var(--esp-3);padding:var(--esp-2) var(--esp-4);border-left:2px solid var(--origem-citacao-barra);background:rgba(0,0,0,.04);border-radius:0 var(--raio-xs) var(--raio-xs) 0}
.pn-msg__citacao-autor{font:var(--texto-micro);color:var(--texto-secundario)}
.pn-msg__citacao-texto{font:var(--texto-legenda);color:var(--texto-terciario);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.pn-msg__imagem{display:flex;align-items:center;justify-content:center;width:220px;height:140px;margin:calc(var(--esp-2) * -1) 0 var(--esp-3);background:var(--superficie-afundada);border:1px solid var(--borda-sutil);border-radius:var(--raio-sm);color:var(--texto-terciario)}
.pn-msg__imagem img{width:100%;height:100%;object-fit:cover;border-radius:inherit}
.pn-msg__transcricao{margin-top:var(--esp-3);padding-top:var(--esp-3);border-top:1px solid var(--borda-sutil)}
.pn-msg__transcricao-rotulo{display:flex;align-items:center;gap:var(--esp-2);font:var(--texto-rotulo);letter-spacing:var(--letra-ampla);text-transform:uppercase;color:var(--texto-terciario);margin-bottom:var(--esp-2)}
.pn-msg__transcricao-texto{font:var(--texto-corpo-denso);color:inherit;opacity:.92}
.pn-msg__meta{display:flex;align-items:center;gap:var(--esp-3);padding:0 var(--esp-1);font:var(--texto-micro);color:var(--texto-terciario);font-variant-numeric:tabular-nums}
.pn-msg--assistente .pn-msg__meta{justify-content:flex-end}
.pn-msg--carregando .pn-msg__balao{color:var(--texto-terciario)}
.pn-msg__erro{display:flex;align-items:center;gap:var(--esp-2);margin-top:var(--esp-2);font:var(--texto-legenda);color:var(--erro-texto)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "bolha-mensagem");
  s.textContent = CSS;
  document.head.appendChild(s);
}
const AUTOR = {
  cliente: {
    icone: "user-round",
    texto: "Cliente"
  },
  assistente: {
    icone: "bot",
    texto: "Assistente"
  },
  sistema: {
    icone: "terminal",
    texto: "Sistema"
  }
};
function BolhaMensagem({
  origem = "cliente",
  tipo = "texto",
  texto,
  transcricao,
  citacao,
  imagem,
  duracao,
  horario,
  entrega,
  processamento,
  detalheProcessamento,
  autor,
  porHumano = false,
  mostrarAutor = true,
  className = "",
  ...resto
}) {
  estilo();
  const a = AUTOR[origem] || AUTOR.cliente;
  const nomeAutor = autor || (porHumano ? "Humano" : a.texto);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `pn-msg pn-msg--${origem} ${className}`.trim()
  }, resto), mostrarAutor && /*#__PURE__*/React.createElement("div", {
    className: "pn-msg__autor"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: porHumano ? "user-check" : a.icone,
    tamanho: 11
  }), /*#__PURE__*/React.createElement("span", null, origem === "sistema" ? autor ? `Sistema · ${autor}` : "Sistema · não enviado ao cliente" : nomeAutor)), /*#__PURE__*/React.createElement("div", {
    className: "pn-msg__balao"
  }, citacao && /*#__PURE__*/React.createElement("div", {
    className: "pn-msg__citacao"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pn-msg__citacao-autor"
  }, citacao.autor), /*#__PURE__*/React.createElement("span", {
    className: "pn-msg__citacao-texto"
  }, citacao.texto)), tipo === "imagem" && /*#__PURE__*/React.createElement("div", {
    className: "pn-msg__imagem"
  }, imagem ? /*#__PURE__*/React.createElement("img", {
    src: imagem,
    alt: texto || "Imagem enviada pelo cliente"
  }) : /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "image",
    tamanho: 22,
    traco: 1.5,
    rotulo: "Imagem"
  })), tipo === "audio" && /*#__PURE__*/React.createElement(__ds_scope.PlayerAudio, {
    duracao: duracao,
    emBalao: true
  }), tipo !== "audio" && texto && /*#__PURE__*/React.createElement("div", null, texto), tipo === "audio" && transcricao && /*#__PURE__*/React.createElement("div", {
    className: "pn-msg__transcricao"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pn-msg__transcricao-rotulo"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "file-text",
    tamanho: 11
  }), "Transcri\xE7\xE3o"), /*#__PURE__*/React.createElement("div", {
    className: "pn-msg__transcricao-texto"
  }, transcricao)), entrega === "falhou" && /*#__PURE__*/React.createElement("div", {
    className: "pn-msg__erro"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "circle-x",
    tamanho: 13
  }), "Falhou ap\xF3s 3 tentativas")), (horario || entrega || processamento) && /*#__PURE__*/React.createElement("div", {
    className: "pn-msg__meta"
  }, horario && /*#__PURE__*/React.createElement("span", null, horario), processamento && /*#__PURE__*/React.createElement(__ds_scope.SeloProcessamento, {
    estado: processamento,
    detalhe: detalheProcessamento
  }), entrega && entrega !== "falhou" && /*#__PURE__*/React.createElement(__ds_scope.IndicadorEntrega, {
    estado: entrega
  })));
}
Object.assign(__ds_scope, { BolhaMensagem });
})();

// components/sinais/SeloSentimento.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-sent{display:inline-flex;align-items:center;gap:var(--esp-2);white-space:nowrap}
.pn-sent__pastilha{display:inline-flex;align-items:center;justify-content:center;flex:none;width:16px;height:16px;border-radius:var(--raio-pilula);color:#fff}
.pn-sent--md .pn-sent__pastilha{width:20px;height:20px}
.pn-sent[data-sentimento=satisfeito] .pn-sent__pastilha{background:var(--sentimento-satisfeito-solido)}
.pn-sent[data-sentimento=neutro] .pn-sent__pastilha{background:var(--sentimento-neutro-solido)}
.pn-sent[data-sentimento=insatisfeito] .pn-sent__pastilha{background:var(--sentimento-insatisfeito-solido)}
.pn-sent__texto{font:var(--texto-meta)}
.pn-sent[data-sentimento=satisfeito] .pn-sent__texto{color:var(--sentimento-satisfeito-texto)}
.pn-sent[data-sentimento=neutro] .pn-sent__texto{color:var(--sentimento-neutro-texto)}
.pn-sent[data-sentimento=insatisfeito] .pn-sent__texto{color:var(--sentimento-insatisfeito-texto)}
.pn-sent--selo{padding:var(--esp-selo-y) var(--esp-selo-x) var(--esp-selo-y) var(--esp-1);border:1px solid transparent;border-radius:var(--raio-xs)}
.pn-sent--selo[data-sentimento=satisfeito]{background:var(--sentimento-satisfeito-superficie);border-color:var(--sentimento-satisfeito-borda)}
.pn-sent--selo[data-sentimento=neutro]{background:var(--sentimento-neutro-superficie);border-color:var(--sentimento-neutro-borda)}
.pn-sent--selo[data-sentimento=insatisfeito]{background:var(--sentimento-insatisfeito-superficie);border-color:var(--sentimento-insatisfeito-borda)}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "sentimento");
  s.textContent = CSS;
  document.head.appendChild(s);
}
const MAPA = {
  satisfeito: {
    glifo: "arrow-up",
    texto: "Satisfeito"
  },
  neutro: {
    glifo: "minus",
    texto: "Neutro"
  },
  insatisfeito: {
    glifo: "arrow-down",
    texto: "Insatisfeito"
  }
};
function SeloSentimento({
  sentimento = "neutro",
  comRotulo = false,
  tamanho = "sm",
  className = "",
  ...resto
}) {
  estilo();
  const m = MAPA[sentimento] || MAPA.neutro;
  const px = tamanho === "md" ? 13 : 11;
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `pn-sent ${comRotulo ? "pn-sent--selo" : ""} pn-sent--${tamanho} ${className}`.trim(),
    "data-sentimento": sentimento,
    title: comRotulo ? undefined : m.texto
  }, resto), /*#__PURE__*/React.createElement("span", {
    className: "pn-sent__pastilha"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: m.glifo,
    tamanho: px,
    traco: 3
  })), comRotulo ? /*#__PURE__*/React.createElement("span", {
    className: "pn-sent__texto"
  }, m.texto) : /*#__PURE__*/React.createElement("span", {
    className: "apenas-leitor"
  }, "Sentimento: ", m.texto));
}
Object.assign(__ds_scope, { SeloSentimento });
})();

// components/conversa/ItemConversa.jsx
(() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS = `
.pn-item{position:relative;display:flex;align-items:center;gap:var(--esp-5);width:100%;min-height:var(--altura-item-conversa);padding:var(--esp-linha-y) var(--esp-lista-x) var(--esp-linha-y) calc(var(--esp-lista-x) + 3px);border:0;border-bottom:1px solid var(--borda-sutil);background:var(--superficie-painel);text-align:left;cursor:pointer;transition:var(--transicao-toque)}
.pn-item:hover{background:var(--superficie-hover)}
.pn-item:focus-visible{outline:var(--foco-largura) solid var(--foco-anel);outline-offset:calc(var(--foco-largura) * -1)}
.pn-item[data-selecionado]{background:var(--superficie-selecionada)}
.pn-item[data-encerrada] .pn-item__avatar,.pn-item[data-encerrada] .pn-item__corpo{opacity:.6}
.pn-item__trilho{position:absolute;left:0;top:0;bottom:0;width:3px}
.pn-item[data-controle=ia] .pn-item__trilho{background:var(--controle-ia-solido)}
.pn-item[data-controle=humano] .pn-item__trilho{background:var(--controle-humano-solido)}
.pn-item[data-encerrada] .pn-item__trilho{background:var(--borda-forte)}
.pn-item__avatar{position:relative;flex:none;display:flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:var(--raio-pilula);background:var(--superficie-afundada);border:1px solid var(--borda-sutil);font:var(--texto-meta);color:var(--texto-secundario);letter-spacing:var(--letra-apertada)}
[data-densidade=compacta] .pn-item__avatar{width:28px;height:28px;font:var(--texto-micro)}
[data-densidade=confortavel] .pn-item__avatar{width:40px;height:40px;font:var(--texto-corpo-forte)}
.pn-item__presenca{position:absolute;right:-1px;bottom:-1px;width:9px;height:9px;border-radius:var(--raio-pilula);border:2px solid var(--superficie-painel)}
.pn-item[data-selecionado] .pn-item__presenca{border-color:var(--superficie-selecionada)}
.pn-item__presenca[data-presenca=disponivel]{background:var(--presenca-disponivel)}
.pn-item__presenca[data-presenca=indisponivel]{background:var(--presenca-indisponivel)}
.pn-item__presenca[data-presenca=digitando]{background:var(--presenca-digitando)}
.pn-item__presenca[data-presenca=gravando]{background:var(--presenca-gravando)}
.pn-item__corpo{display:flex;flex-direction:column;gap:2px;flex:1;min-width:0}
.pn-item__linha{display:flex;align-items:center;gap:var(--esp-3);min-width:0}
.pn-item__nome{font:var(--texto-corpo-forte);color:var(--texto-primario);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.pn-item__controle-glifo{flex:none;display:flex}
.pn-item[data-controle=ia] .pn-item__controle-glifo{color:var(--controle-ia-texto)}
.pn-item[data-controle=humano] .pn-item__controle-glifo{color:var(--controle-humano-texto)}
.pn-item__horario{flex:none;margin-left:auto;font:var(--texto-micro);color:var(--texto-terciario);font-variant-numeric:tabular-nums}
.pn-item__previa{flex:1;min-width:0;display:flex;align-items:center;gap:var(--esp-2);font:var(--texto-corpo-denso);color:var(--texto-terciario);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.pn-item__previa span{overflow:hidden;text-overflow:ellipsis}
.pn-item__previa[data-nao-lida]{color:var(--texto-secundario);font-weight:var(--peso-medio)}
.pn-item__direita{flex:none;display:flex;align-items:center;gap:var(--esp-3)}
.pn-item__contador{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;border-radius:var(--raio-pilula);background:var(--acao-primaria-fundo);color:var(--acao-primaria-texto);font:var(--texto-micro);font-variant-numeric:tabular-nums}
.pn-item__encerrada{display:inline-flex;align-items:center;gap:3px;flex:none;font:var(--texto-micro);color:var(--texto-terciario)}
.pn-item__silencio{flex:none;display:inline-flex;align-items:center;gap:2px;font:var(--texto-micro);color:var(--controle-humano-texto);font-variant-numeric:tabular-nums}
`;
let injetado = false;
function estilo() {
  if (injetado || typeof document === "undefined") return;
  injetado = true;
  const s = document.createElement("style");
  s.setAttribute("data-pn", "item-conversa");
  s.textContent = CSS;
  document.head.appendChild(s);
}
const ICONE_TIPO = {
  audio: "mic",
  imagem: "image",
  sistema: "terminal"
};
function iniciais(nome = "") {
  const p = nome.trim().split(/\s+/);
  return ((p[0]?.[0] || "") + (p.length > 1 ? p[p.length - 1][0] : "")).toUpperCase();
}
function ItemConversa({
  nome,
  previa,
  tipoPrevia = "texto",
  horario,
  presenca = "indisponivel",
  sentimento,
  controle = "ia",
  tempoRestante,
  estado = "aberta",
  naoLidas = 0,
  selecionado = false,
  className = "",
  ...resto
}) {
  estilo();
  const encerrada = estado === "encerrada";
  const vivo = presenca === "digitando" || presenca === "gravando";
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    className: `pn-item ${className}`.trim(),
    "data-selecionado": selecionado ? "" : undefined,
    "data-encerrada": encerrada ? "" : undefined,
    "data-controle": encerrada ? undefined : controle,
    "aria-current": selecionado ? "true" : undefined
  }, resto), /*#__PURE__*/React.createElement("span", {
    className: "pn-item__trilho",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    className: "pn-item__avatar",
    "aria-hidden": "true"
  }, iniciais(nome), /*#__PURE__*/React.createElement("span", {
    className: "pn-item__presenca",
    "data-presenca": presenca
  })), /*#__PURE__*/React.createElement("span", {
    className: "pn-item__corpo"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pn-item__linha"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pn-item__controle-glifo"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: controle === "humano" ? "user-round" : "bot",
    tamanho: 12,
    rotulo: controle === "humano" ? "Conduzida por humano" : "Conduzida pela IA"
  })), /*#__PURE__*/React.createElement("span", {
    className: "pn-item__nome"
  }, nome), encerrada && /*#__PURE__*/React.createElement("span", {
    className: "pn-item__encerrada"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "circle-check",
    tamanho: 11
  }), "Encerrada"), !encerrada && controle === "humano" && tempoRestante && /*#__PURE__*/React.createElement("span", {
    className: "pn-item__silencio"
  }, /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: "bell-off",
    tamanho: 11
  }), tempoRestante, /*#__PURE__*/React.createElement("span", {
    className: "apenas-leitor"
  }, " restantes de IA silenciada")), /*#__PURE__*/React.createElement("span", {
    className: "pn-item__horario"
  }, horario)), /*#__PURE__*/React.createElement("span", {
    className: "pn-item__linha"
  }, vivo ? /*#__PURE__*/React.createElement("span", {
    className: "pn-item__previa"
  }, /*#__PURE__*/React.createElement(__ds_scope.IndicadorPresenca, {
    presenca: presenca
  })) : /*#__PURE__*/React.createElement("span", {
    className: "pn-item__previa",
    "data-nao-lida": naoLidas > 0 ? "" : undefined
  }, ICONE_TIPO[tipoPrevia] && /*#__PURE__*/React.createElement(__ds_scope.Icone, {
    nome: ICONE_TIPO[tipoPrevia],
    tamanho: 12
  }), /*#__PURE__*/React.createElement("span", null, previa)), /*#__PURE__*/React.createElement("span", {
    className: "pn-item__direita"
  }, sentimento && /*#__PURE__*/React.createElement(__ds_scope.SeloSentimento, {
    sentimento: sentimento
  }), naoLidas > 0 && /*#__PURE__*/React.createElement("span", {
    className: "pn-item__contador"
  }, naoLidas, /*#__PURE__*/React.createElement("span", {
    className: "apenas-leitor"
  }, " n\xE3o lidas"))))));
}
Object.assign(__ds_scope, { ItemConversa });
})();

export const { GLIFOS, Icone, PlayerAudio, CampoBusca, CartaoMetrica, Alternador, Botao, Estado, BotaoIcone, Modal, Notificacao, PilhaNotificacoes, PainelLateral, Caixa, TabelaDensa, Campo, Selecao, BarraFiltros, IndicadorEntrega, IndicadorPresenca, Selo, SeloControle, SeloConversa, SeloProcessamento, BolhaMensagem, SeloSentimento, ItemConversa } = __ds_scope;
